import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnChanges, SimpleChanges, Input, Output, EventEmitter} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Banque} from '../../../../../../models/banque.model';
import {CroudCompteBancaireComponent} from '../../../../../parametre/compte-bancaire/croud-compte-bancaire/croud-compte-bancaire.component';
import {PaiementService} from '../../../../../../services/paiement/paiement.service';
import {TresorerieService} from '../../../../../../services/tresorerie/tresorerie.service';
import {DocumentService} from '../../../../../../services/document/document.service';
import {DataService} from '../../../../../../services/commande-client/data.service';
import {BanqueService} from '../../../../../../services/Banque/banque.service';
import {StationService} from '../../../../../../services/station.service';
import {Tresorerie} from '../../../../../../models/Tresorerie/Tresorerie';
import {ChequeTraite} from '../../../../../../models/Tresorerie/ChequeTraite';
import {Solde} from '../../../../../../models/Tresorerie/Solde';
import {Paiement} from '../../../../../../models/paiement/Paiement';
import {LignePaiement} from '../../../../../../models/paiement/LignePaiement';
import {PaiementNonAffecte} from '../../../../../../models/paiement/PaiementNonAffecte';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Component({
    selector: 'app-nouveau-paiement',
    templateUrl: './nouveau-paiement.component.html',
    styleUrls: ['./nouveau-paiement.component.scss']
})
export class NouveauPaiementComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('croud') croudCompteBancaire!: CroudCompteBancaireComponent;
    selectedFiles: File[] = [];
    selectedFile: File | null = null;
    pieceJointe = {nom: false, taille: false, derniereMiseAJour: false};
    readonly MAX_FILE_SIZE = 1024 * 1024;
    private fileInputsBySection: Map<number, HTMLInputElement> = new Map();
    file_url: string = 'http://127.0.0.1:8000'; // URL par défaut pour les uploads de fichiers
    private modalRef!: NgbModalRef;
    isAddCardActive: boolean = false;
    showModal: boolean = false;
    idStation: number | undefined;
    valeurRetenue: boolean = false;
    retenueSelection: string = 'non';
    currentSoldePrimaire: string = '0.00';
    currentSoldeSecondaire: string = '0.00';
    /** Liste dynamique des caisses/soldes (API trésorerie). */
    soldesList: Solde[] = [];
    /** Map type_solde -> montant_total (format string) pour affichage rapide. */
    soldesByType: Record<string, string> = {};

    banques: Banque[] = []; // Liste des banques chargées depuis l'API
    comptesBancaires: Banque[] = []; // Liste des comptes bancaires chargés depuis l'API

    allSections: { id: number; type: 'espece' | 'cheque' | 'virement' | 'traite' | 'avoir'; isContentVisible: boolean; data?: any; isExisting?: boolean }[] = [];
    sectionCounter: number = 1; // Compteur global pour les ids (#1, #2, etc.)
    fenetre: number = 0; // Compteur global des clics/ajouts
    private existingPaiementId: number | null = null; // ID du paiement existant si on est en mode mise à jour
    @Input() resteAPayer: number = 0;
    @Input() montantInitialSuggere: number = 0;
    @Input() documentId: number | null = null;
    @Input() clientId: number | null = null; // client_id du document (facture vente)
    @Input() fournisseurId: number | null = null; // fournisseur_id du document (facture fournisseur, obligatoire pour achat)
    @Input() documentRefExterne: string | null = null; // ref_externe du document (facture)
    /** Quand le document ouvert est un avoir : id de la facture d'origine (document_original_id). Utilisé comme document_id dans le payload. */
    @Input() factureIdForAvoir: number | null = null;
    @Input() montantTotal: number = 0; // Total TTC de la facture (avec timbre)
    @Input() montantHT: number = 0; // Total HT (optionnel)
    @Input() montantTVA: number = 0; // Total TVA (optionnel)
    @Input() timbreFiscal: number = 0; // Montant du timbre fiscal
    @Input() documentType: string = 'facture'; // Type de document : 'facture' (vente), 'facture-fournisseur' (achat) ou 'avoir'
    @Input() documentStatut: string | null = null; // Libellé du statut (ex. "Non utilisé", "Partiellement utilisé")
    @Input() documentStatutId: number | null = null; // ID du statut : 19 = Non utilisé, 20 = Partiellement utilisé → afficher section Avoir
    @Input() triggerCreate: boolean = false; // Déclencheur pour créer le paiement depuis le parent
    @Input() avoirSelectionne: any = null; // Avoir choisi depuis l'onglet "Depuis un avoir" pour pré-remplir une ligne
    /** Émet le paiement créé ; si avoir : peut émettre { paiement, avoirStatutId, avoirStatutLabel } pour le parent et le refresh. */
    @Output() paiementCreated = new EventEmitter<Paiement | { paiement: Paiement; avoirStatutId: number; avoirStatutLabel?: string }>();
    /** Émet le reste à payer TTC calculé (net à payer TTC − total des montants saisis) pour affichage dans le parent. */
    @Output() resteAPayerCalcule = new EventEmitter<number>();

    /** Avoir dont le montant est pré-rempli dans une section ; après création du paiement, son statut passera à "Utilisé" */
    private avoirPourPaiement: any = null;

    timbreSelection: string = 'non';
    montantTTC: number = 0; // Montant TTC (reste inchangé)
    netAPayer: number = 0;
    montantRetenue: number = 0;

    // Paramètres de configuration RS
    tauxRS: string = '1'; // 1%, 1.5%, 5%, 10%
    inclureTimbreDansBaseRS: boolean = false;

    // Flag pour éviter les appels multiples simultanés à createTresorerieOperations
    private isCreatingTresorerieOperations: boolean = false;

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private paiementService: PaiementService,
        private tresorerieService: TresorerieService,
        private documentService: DocumentService,
        private dataService: DataService,
        private banqueService: BanqueService,
        private stationService: StationService
    ) {
    }

    ngOnInit(): void {
        // Récupérer l'ID de la station depuis le localStorage
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.idStation = currentUser?.stations?.[0]?.id;

        // Logger le documentType pour vérification
        console.log('📋 [ngOnInit] documentType initial:', this.documentType);

        // Initialiser les calculs (calculateTotals appelle emitResteAPayerCalcule)
        if (this.montantTotal > 0) {
            this.calculateTotals();
        } else {
            this.emitResteAPayerCalcule();
        }

        // Charger les soldes pour afficher les montants dans les sections
        this.loadSoldes();

        // Charger les banques depuis l'API
        this.loadBanques();

        // Charger les comptes bancaires depuis l'API
        this.loadComptesBancaires();

        // Charger le paiement existant si documentId est disponible
        if (this.documentId) {
            // Vérifier d'abord si un paiement existe pour définir existingPaiementId
            this.checkExistingPaiement();
            this.loadExistingPaiement();
        }
    }

    ngAfterViewInit(): void {
        // Le composant est maintenant disponible dans la vue
        console.log('ngAfterViewInit - croudCompteBancaire:', this.croudCompteBancaire);
        console.log('ngAfterViewInit - idStation:', this.idStation);
        
        // Forcer la détection des changements pour s'assurer que le composant est initialisé
        this.cdr.detectChanges();
        
        // Vérifier à nouveau après un court délai
        setTimeout(() => {
            console.log('ngAfterViewInit (après timeout) - croudCompteBancaire:', this.croudCompteBancaire);
        }, 100);
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Si triggerCreate change et devient true, créer le paiement
        if (changes['triggerCreate'] && changes['triggerCreate'].currentValue === true) {
            console.log('🔄 [ngOnChanges] triggerCreate activé, création du paiement');
            this.createPaiement();
            // Réinitialiser le trigger
            setTimeout(() => {
                this.triggerCreate = false;
            }, 100);
        }

        // Si montantTotal change, recalculer les totaux et émettre le netAPayer
        if (changes['montantTotal'] && changes['montantTotal'].currentValue) {
            console.log('🔄 [ngOnChanges] montantTotal changé:', this.montantTotal);
            this.calculateTotals();
            // Le netAPayer sera émis automatiquement dans calculateTotals()
        }

        // Si documentId change, charger le paiement existant
        if (changes['documentId'] && changes['documentId'].currentValue) {
            console.log('🔄 [ngOnChanges] documentId changé, chargement du paiement existant');
            // Recharger les soldes pour s'assurer qu'ils sont à jour
            this.loadSoldes();
            // Vérifier d'abord si un paiement existe pour définir existingPaiementId
            this.checkExistingPaiement();
            this.loadExistingPaiement();
        }

        // Si resteAPayer change (ex. après recalcul asynchrone du parent), réémettre le reste pour l'affichage et l'input montant
        if (changes['resteAPayer'] && changes['resteAPayer'].currentValue !== undefined) {
            // Réémettre pour que la colonne "RESTE à PAYER" du parent reste cohérente avec l'input montant
            this.emitResteAPayerCalcule();
            this.cdr.detectChanges();
        }

        // Si un avoir est sélectionné depuis "Depuis un avoir", ajouter une section Avoir (uniquement montant)
        if (changes['avoirSelectionne'] && changes['avoirSelectionne'].currentValue) {
            const payload = changes['avoirSelectionne'].currentValue;
            const avoir = payload?.avoir ?? payload;
            const avoirId = this.getDocumentIdFromAvoir(avoir);
            if (avoir && avoirId != null && avoirId !== this.getDocumentIdFromAvoir(this.avoirPourPaiement)) {
                this.avoirPourPaiement = avoir;
                const montantRestant = payload?.montantRestant != null ? parseFloat(String(payload.montantRestant).replace(',', '.')) : NaN;
                const montant = !isNaN(montantRestant) && montantRestant >= 0 ? montantRestant : this.getMontantAvoir(avoir);
                this.addSectionWithSoldes('avoir', { montant, avoir_id: avoirId });
                console.log('📋 [ngOnChanges] Section Avoir ajoutée pour avoir, montant (reste):', montant, 'TND');
            }
        }
        // Si on ouvre le paiement pour un avoir (documentType='avoir' OU statut "Non utilisé" / "Partiellement utilisé"), ajouter la section Avoir (uniquement input montant)
        if (this.shouldShowSectionAvoir() && this.documentId) {
            if (changes['documentType'] || changes['documentId'] || changes['documentStatut']) {
                this.addSectionAvoirForDocumentAvoir();
            }
        }
    }

    /** IDs statut avoir (aligné avec paiement-facture et depuis-avoir) : 19 = Non utilisé, 20 = Partiellement utilisé. */
    private readonly STATUT_AVOIR_IDS = [19, 20];

    /** True si le document est un avoir : type Avoir, statut_id 19/20, ou libellé "Non utilisé" / "Partiellement utilisé". */
    private shouldShowSectionAvoir(): boolean {
        if (this.documentType === 'avoir') return true;
        if (this.documentStatutId != null && this.STATUT_AVOIR_IDS.includes(Number(this.documentStatutId))) return true;
        const s = (this.documentStatut ?? '').toString().trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return s === 'non utilise' || s === 'partiellement utilise';
    }

    /**
     * En statut "Partiellement payé", on interdit la suppression des sections
     * (l'icône corbeille ne doit pas être affichée dans le popup).
     */
    isFacturePartiellementPayee(): boolean {
        if (this.documentType !== 'facture' && this.documentType !== 'facture-fournisseur') {
            return false;
        }
        if (this.documentStatutId != null && Number(this.documentStatutId) === 15) {
            return true;
        }
        const statutNormalise = (this.documentStatut ?? '')
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        return statutNormalise.includes('partiellement paye');
    }

    onRetenueChange(value: string): void {
        this.retenueSelection = value;
        this.valeurRetenue = value === 'oui';
        this.calculateTotals();
        this.cdr.markForCheck();
    }

    onTimbreChange(value: string): void {
        this.timbreSelection = value;
        // Utiliser les radio buttons pour gérer l'inclusion du timbre dans la base RS
        this.inclureTimbreDansBaseRS = value === 'oui';

        // Calculer le sous-total TTC (sans timbre)
        const sousTotalTTC = this.montantTotal - this.timbreFiscal;

        // Afficher dans la console selon la sélection
        if (value === 'oui') {
            console.log('✅ Timbre fiscal: OUI sélectionné');
            console.log('📊 Total TTC du document (avec timbre):', this.montantTotal, 'TND');
            console.log('📊 Timbre fiscal:', this.timbreFiscal, 'TND');
        } else {
            console.log('❌ Timbre fiscal: NON sélectionné');
            console.log('📊 Sous-total TTC du document (sans timbre):', sousTotalTTC, 'TND');
            console.log('📊 Total TTC (avec timbre):', this.montantTotal, 'TND');
            console.log('📊 Timbre fiscal soustrait:', this.timbreFiscal, 'TND');
        }

        this.calculateTotals();
        this.cdr.markForCheck();
    }



    onTauxRSChange(value: string): void {
        this.tauxRS = value;
        this.calculateTotals();
        this.cdr.markForCheck();
    }


    calculateTotals(): void {
        // RÈGLE 1: Le montant TTC reste inchangé (c'est le montant de la facture)
        this.montantTTC = this.montantTotal;

        // Calculer le sous-total TTC (TTC sans timbre fiscal)
        const sousTotalTTC = this.montantTotal - this.timbreFiscal;

        // Calculer la retenue à la source si activée
        // IMPORTANT: Montant_RS n'est calculé QUE si retenue = "oui"
        if (this.valeurRetenue) {
            // Déterminer la base de calcul RS selon la sélection du timbre fiscal
            let baseRS = 0;

            if (this.timbreSelection === 'non') {
                // Si "Non" est sélectionné : Base_RS = SousTotal_TTC (TTC sans timbre)
                baseRS = sousTotalTTC;
                console.log('🔢 Calcul RS - Base utilisée: Sous-total TTC =', baseRS, 'TND');
            } else {
                // Si "Oui" est sélectionné : Base_RS = Total_TTC (TTC avec timbre)
                baseRS = this.montantTotal;
                console.log('🔢 Calcul RS - Base utilisée: Total TTC =', baseRS, 'TND');
            }

            // Calculer le montant RS = Base_RS × Taux_RS
            const tauxRSDecimal = parseFloat(this.tauxRS) / 100;
            this.montantRetenue = baseRS * tauxRSDecimal;
            console.log('💰 Montant RS calculé:', this.montantRetenue, 'TND (Base:', baseRS, '× Taux:', this.tauxRS + '%)');
        } else {
            // Si retenue = "non", Montant_RS = 0
            this.montantRetenue = 0;
            console.log('ℹ️ Retenue désactivée, Montant_RS = 0');
        }

        // RÈGLE 2: Net à payer = Total TTC - Montant RS
        // IMPORTANT: Ce calcul est TOUJOURS appliqué, même si Montant_RS = 0
        // Si retenue = "non" : Net à payer = Total TTC - 0 = Total TTC
        // Si retenue = "oui" : Net à payer = Total TTC - Montant_RS
        this.netAPayer = this.montantTTC - this.montantRetenue;
        console.log('💵 Net à payer:', this.netAPayer, 'TND (Total TTC:', this.montantTTC, '- Montant_RS:', this.montantRetenue, ')');
        console.log('📊 Résumé: Montant TTC =', this.montantTTC, ', Montant RS =', this.montantRetenue, ', Net à payer =', this.netAPayer);
        this.emitResteAPayerCalcule();
    }

    toggleEspeceBox(): void {
        // Calculer le montant par défaut : reste à payer si première section, sinon reste restant
        const montantDefaut = this.calculateMontantDefaut();

        if ((this.currentSoldePrimaire === '0.00' && this.currentSoldeSecondaire === '0.00') && this.idStation) {
            this.loadSoldesAndAddSection('espece', {
                montant: montantDefaut,
                date_reglement: new Date().toISOString().split('T')[0],
                soldeType: 'primaire'
            });
        } else {
            this.addSectionWithSoldes('espece', {
                montant: montantDefaut,
                date_reglement: new Date().toISOString().split('T')[0],
                soldeType: 'primaire'
            });
        }
    }

    // Ajouter une section pour Chèque
    toggleChequeBox(): void {
        // Calculer le montant par défaut : reste à payer si première section, sinon reste restant
        const montantDefaut = this.calculateMontantDefaut();

        if ((this.currentSoldePrimaire === '0.00' && this.currentSoldeSecondaire === '0.00') && this.idStation) {
            this.loadSoldesAndAddSection('cheque', {
                montant: montantDefaut,
                porteur: '',
                banque_id: null,
                numero_cheque: '',
                soldeType: 'primaire'
            });
        } else {
            this.addSectionWithSoldes('cheque', {
                montant: montantDefaut,
                porteur: '',
                banque_id: null,
                numero_cheque: '',
                soldeType: 'primaire'
            });
        }
    }

    // Ajouter une section pour Virement bancaire
    toggleVirementBox(): void {
        // Calculer le montant par défaut : reste à payer si première section, sinon reste restant
        const montantDefaut = this.calculateMontantDefaut();

        if ((this.currentSoldePrimaire === '0.00' && this.currentSoldeSecondaire === '0.00') && this.idStation) {
            this.loadSoldesAndAddSection('virement', {
                montant: montantDefaut,
                informations_virement: '',
                date_reglement: new Date().toISOString().split('T')[0],
                compte_bancaire_id: null,
                soldeType: 'primaire'
            });
        } else {
            this.addSectionWithSoldes('virement', {
                montant: montantDefaut,
                informations_virement: '',
                date_reglement: new Date().toISOString().split('T')[0],
                compte_bancaire_id: null,
                soldeType: 'primaire'
            });
        }
    }

    // Ajouter une section pour Traite
    toggleTraiteBox(): void {
        // Calculer le montant par défaut : reste à payer si première section, sinon reste restant
        const montantDefaut = this.calculateMontantDefaut();

        if ((this.currentSoldePrimaire === '0.00' && this.currentSoldeSecondaire === '0.00') && this.idStation) {
            this.loadSoldesAndAddSection('traite', {
                montant: montantDefaut,
                compte_source: '',
                numero_traite: '',
                date_reglement: new Date().toISOString().split('T')[0],
                date_echeance: '',
                compte_bancaire_id: null,
                soldeType: 'primaire'
            });
        } else {
            this.addSectionWithSoldes('traite', {
                montant: montantDefaut,
                compte_source: '',
                numero_traite: '',
                date_reglement: new Date().toISOString().split('T')[0],
                date_echeance: '',
                compte_bancaire_id: null,
                soldeType: 'primaire'
            });
        }
    }

    /**
     * Montant par défaut pour l'input Montant = toujours le reste à payer affiché dans le parent.
     * Utilise getResteAPayerCalcule() pour être cohérent avec la colonne "RESTE à PAYER" du modal.
     */
    private calculateMontantDefaut(): number {
        return this.getResteAPayerCalcule();
    }

    /**
     * Reste à payer affiché dans le parent (colonne "RESTE à PAYER").
     * - Retenue à la source = Non : base = le montant (total TTC facture).
     * - Retenue à la source = Oui : base = Net à payer TTC (montantTotal - Montant_RS).
     */
    getResteAPayerCalcule(): number {
        const totalSaisi = this.allSections.reduce((sum, s) => {
            const m = s.data?.montant;
            if (typeof m === 'number') return sum + m;
            if (m != null) return sum + (parseFloat(String(m)) || 0);
            return sum;
        }, 0);
        // Base selon retenue : Non = montant (total) ; Oui = Net à payer TTC
        const baseMontant = this.valeurRetenue
            ? this.netAPayer
            : (this.allSections.length === 0 && this.resteAPayer > 0 ? this.resteAPayer : this.montantTotal);
        return Math.max(0, baseMontant - totalSaisi);
    }

    /** Émet le reste à payer TTC calculé vers le parent pour affichage. */
    private emitResteAPayerCalcule(): void {
        this.resteAPayerCalcule.emit(this.getResteAPayerCalcule());
    }

    // Basculer l'affichage du contenu d'une section (globale)
    toggleContent(sectionId: number): void {
        const section = this.allSections.find(s => s.id === sectionId);
        if (section) {
            section.isContentVisible = !section.isContentVisible;
        }
        this.cdr.markForCheck();
    }

    /**
     * Supprime une section. Si la section a un tresorerie_id (ligne chargée depuis un paiement existant),
     * appelle DELETE /api/tresorerie/:tresorerie_id puis retire la section. Sinon retire uniquement la section.
     */
    deleteSection(sectionId: number): void {
        const section = this.allSections.find(s => s.id === sectionId);
        if (!section) return;

        const tresorerieId = section.data?.tresorerie_id != null ? Number(section.data.tresorerie_id) : null;
        if (tresorerieId != null && !isNaN(tresorerieId)) {
            this.tresorerieService.deleteTresorerie(tresorerieId).subscribe({
                next: () => {
                    this.removeSectionFromList(sectionId);
                    this.toastr.success('Ligne de trésorerie supprimée', 'Succès');
                    this.cdr.markForCheck();
                    // Mettre à jour le paiement côté backend : retirer la ligne liée à cette trésorerie
                    // pour qu'elle ne réapparaisse pas à la réouverture du popup
                    this.removeLignePaiementByTresorerieId(tresorerieId);
                },
                error: (err) => {
                    console.error('Erreur suppression trésorerie:', err);
                    this.toastr.error(err?.error?.message || 'Erreur lors de la suppression de la trésorerie', 'Erreur');
                }
            });
        } else {
            this.removeSectionFromList(sectionId);
            this.cdr.markForCheck();
        }
    }

    private removeSectionFromList(sectionId: number): void {
        if (this.fenetre > 0) {
            this.fenetre = this.fenetre - 1;
        }
        this.allSections = this.allSections.filter(s => s.id !== sectionId);
        this.emitResteAPayerCalcule();
    }

    /**
     * Après suppression d'une trésorerie, retire la ligne de paiement correspondante du paiement côté backend,
     * pour qu'elle ne réapparaisse pas à la réouverture du popup.
     */
    private removeLignePaiementByTresorerieId(tresorerieId: number): void {
        if (this.existingPaiementId == null) {
            return;
        }
        this.paiementService.getPaiementById(this.existingPaiementId).subscribe({
            next: (response: any) => {
                let paiement: Paiement;
                if (response?.data?.paiement) {
                    paiement = response.data.paiement;
                } else if (response?.data && Array.isArray(response.data) && response.data.length > 0) {
                    paiement = response.data[0];
                } else if (response?.id) {
                    paiement = response;
                } else {
                    return;
                }
                const lignes = paiement.lignes_paiement || [];
                const tid = tresorerieId;
                const filtered = lignes.filter((l) => (l.tresorerie_id ?? (l as any).tresorerie_id) !== tid);
                if (filtered.length >= lignes.length) {
                    return;
                }
                const updated: Paiement = { ...paiement, lignes_paiement: filtered };
                this.paiementService.updatePaiement(this.existingPaiementId!, updated).subscribe({
                    next: () => {},
                    error: (err) => {
                        console.error('Erreur mise à jour paiement (retrait ligne):', err);
                        this.toastr.error(err?.error?.message || 'Erreur lors de la mise à jour du paiement', 'Erreur');
                    }
                });
            },
            error: (err) => {
                console.error('Erreur chargement paiement pour retrait ligne:', err);
            }
        });
    }

    triggerFileInput(event: MouseEvent, sectionId: number): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.fileInput?.nativeElement) {
            // Stocker la section ID pour l'utiliser dans onFileSelected
            (this.fileInput.nativeElement as any).sectionId = sectionId;
            this.fileInput.nativeElement.click();
        } else {
            console.error('fileInput is not available');
            this.toastr.error('Erreur lors de l\'ouverture du sélecteur de fichiers', 'Erreur');
        }
    }

    onFileSelected(event: Event, sectionId: number): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const files = Array.from(input.files);
            if (files.length > 10) {
                this.toastr.error('Maximum 10 fichiers autorisés', 'Erreur');
                input.value = '';
                return;
            }
            const invalidFiles = files.filter(file => !file.name.endsWith('.pdf') || file.size > this.MAX_FILE_SIZE);
            if (invalidFiles.length > 0) {
                this.toastr.error('Seuls les PDFs de moins de 1 Mo sont autorisés', 'Erreur');
                input.value = '';
                return;
            }
            
            // Associer les fichiers à la section spécifique
            const section = this.allSections.find(s => s.id === sectionId);
            if (section) {
                if (!section.data) {
                    section.data = {};
                }
                section.data.fichiers = files;
                this.toastr.success(`${files.length} fichier(s) sélectionné(s) pour la section #${sectionId}`, 'Succès');
            }
            
            this.cdr.markForCheck();
        }
    }

    importFile(): void {
        if (this.selectedFiles.length > 0) {
            console.log('Importing files:', this.selectedFiles.map(f => ({
                name: f.name,
                size: this.pieceJointe.taille ? f.size : undefined,
                lastModified: this.pieceJointe.derniereMiseAJour ? f.lastModified : undefined
            })));
            this.toastr.success(`${this.selectedFiles.length} fichier(s) importé(s) avec succès`, 'Succès');
            this.clearFileSelection();
            this.modalRef.close('Import success');
        } else {
            this.toastr.error('Aucun fichier sélectionné', 'Erreur');
        }
    }

    private clearFileSelection(): void {
        this.selectedFiles = [];
        this.selectedFile = null;
        this.pieceJointe = {nom: false, taille: false, derniereMiseAJour: false};
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
        this.cdr.markForCheck();
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    onDrop(event: DragEvent, sectionId: number): void {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer?.files) {
            const files = Array.from(event.dataTransfer.files);
            if (files.length > 10) {
                this.toastr.error('Maximum 10 fichiers autorisés', 'Erreur');
                return;
            }
            const invalidFiles = files.filter(file => !file.name.endsWith('.pdf') || file.size > this.MAX_FILE_SIZE);
            if (invalidFiles.length > 0) {
                this.toastr.error('Seuls les PDFs de moins de 1 Mo sont autorisés', 'Erreur');
                return;
            }
            
            // Associer les fichiers à la section spécifique
            const section = this.allSections.find(s => s.id === sectionId);
            if (section) {
                if (!section.data) {
                    section.data = {};
                }
                section.data.fichiers = files;
                this.toastr.success(`${files.length} fichier(s) sélectionné(s) pour la section #${sectionId}`, 'Succès');
            }
            
            this.cdr.markForCheck();
        }
    }
    
    getSectionFiles(sectionId: number): File[] {
        const section = this.allSections.find(s => s.id === sectionId);
        return section?.data?.fichiers || [];
    }

    /**
     * Formater le champ fichier pour le backend
     * Convertit un tableau de chemins en une chaîne JSON ou une chaîne séparée par des virgules
     */
    private formatFichierField(fichiersUploades: string[] | string | null | undefined): string | null {
        if (!fichiersUploades) {
            return null;
        }
        
        // Si c'est déjà une chaîne, la retourner telle quelle
        if (typeof fichiersUploades === 'string') {
            return fichiersUploades;
        }
        
        // Si c'est un tableau, le convertir en chaîne JSON
        if (Array.isArray(fichiersUploades)) {
            if (fichiersUploades.length === 0) {
                return null;
            }
            // Utiliser JSON.stringify pour convertir le tableau en chaîne JSON
            return JSON.stringify(fichiersUploades);
        }
        
        return null;
    }

    openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', account?: Banque, newStatut?: boolean): void {
        console.log('openModal appelé avec type:', type);
        console.log('idStation:', this.idStation);
        console.log('croudCompteBancaire:', this.croudCompteBancaire);

        if (!this.idStation) {
            this.toastr.error('ID de station non disponible', 'Erreur');
            return;
        }

        this.showModal = true;
        this.isAddCardActive = type === 'ajouter';
        this.cdr.detectChanges();

        // Attendre que le composant soit disponible avec un maximum de tentatives
        let attempts = 0;
        const maxAttempts = 20; // Maximum 20 tentatives (1 seconde au total)

        const tryOpenModal = () => {
            attempts++;
            console.log(`Tentative ${attempts} - croudCompteBancaire disponible:`, !!this.croudCompteBancaire);

            if (this.croudCompteBancaire) {
                console.log('Ouverture du modal...');
                try {
                    if (type === 'etat' && account) {
                        const action = account.statut ? 'Désactivation' : 'Activation';
                        this.croudCompteBancaire.openModal(type, {...account}, this.idStation, `${action} du compte bancaire`);
                    } else if (type === 'ajouter' || type === 'update') {
                        this.croudCompteBancaire.openModal(type, account ? {...account} : undefined, this.idStation);
                    }
                    console.log('Modal ouvert avec succès');
                } catch (error) {
                    console.error('Erreur lors de l\'ouverture du modal:', error);
                    this.toastr.error('Erreur lors de l\'ouverture du modal', 'Erreur');
                }
            } else if (attempts < maxAttempts) {
                // Réessayer après un court délai
                setTimeout(tryOpenModal, 50);
            } else {
                console.error('Composant croudCompteBancaire non disponible après', maxAttempts, 'tentatives');
                this.toastr.error('Erreur: Composant non disponible. Veuillez réessayer.', 'Erreur');
            }
        };

        // Démarrer la tentative d'ouverture
        setTimeout(tryOpenModal, 100);
    }

    onAccountAdded(account: Banque): void {
        console.log('Compte ajouté:', account);
        this.toastr.success('Compte bancaire ajouté avec succès', 'Succès');
        // Recharger les comptes bancaires pour inclure le nouveau compte
        this.loadComptesBancaires();
    }

    onAccountUpdated(account: Banque): void {
        console.log('Compte mis à jour:', account);
        this.toastr.success('Compte bancaire mis à jour avec succès', 'Succès');
        // Recharger les comptes bancaires pour refléter les modifications
        this.loadComptesBancaires();
    }

    // Méthode pour collecter les données d'une section
    getSectionData(sectionId: number): any {
        const section = this.allSections.find(s => s.id === sectionId);
        if (!section || !section.data) return null;
        return section.data;
    }

    // Méthode spécifique pour gérer le changement de soldeType (désormais dynamique: string)
    onSoldeTypeChange(sectionId: number, soldeType: string): void {
        const section = this.allSections.find(s => s.id === sectionId);
        if (section) {
            if (!section.data) {
                section.data = {};
            }
            
            // Mettre à jour le soldeType de manière explicite et forcée
            section.data.soldeType = soldeType;
            
            // Vérifier que la mise à jour a bien été effectuée
            const verifySoldeType = section.data.soldeType;
            console.log(`🔵 [onSoldeTypeChange] Section #${sectionId}: soldeType changé à "${soldeType}"`);
            console.log(`🔵 [onSoldeTypeChange] Vérification: section.data.soldeType = "${verifySoldeType}"`);
            console.log(`🔵 [onSoldeTypeChange] section.data complet:`, JSON.stringify(section.data, null, 2));
            
            // Forcer la mise à jour du modèle Angular
            this.cdr.detectChanges();
            
            // Vérifier une deuxième fois après detectChanges
            setTimeout(() => {
                const finalCheck = this.allSections.find(s => s.id === sectionId)?.data?.soldeType;
                console.log(`🔵 [onSoldeTypeChange] Vérification finale (après detectChanges): section.data.soldeType = "${finalCheck}"`);
            }, 100);
        } else {
            console.error(`❌ [onSoldeTypeChange] Section #${sectionId} non trouvée`);
        }
    }

    /** Montant d'une caisse (type_solde) pour affichage dans une section. */
    getSoldeMontantForType(typeSolde: string): string {
        const v = this.soldesByType?.[typeSolde];
        if (v == null) return '0.00';
        const n = parseFloat(String(v).replace(',', '.'));
        return isNaN(n) ? '0.00' : n.toFixed(2);
    }

    // Méthode pour mettre à jour les données d'une section
    updateSectionData(sectionId: number, field: string, value: any): void {
        const section = this.allSections.find(s => s.id === sectionId);
        if (section) {
            if (!section.data) {
                section.data = {};
            }
            
            // Pour le champ montant, arrondir précisément à 2 décimales pour éviter les erreurs d'arrondi
            if (field === 'montant' && value !== null && value !== undefined && value !== '') {
                // Convertir en nombre en gérant les virgules et points
                let valeurNettoyee = value.toString().trim();
                // Remplacer la virgule par un point pour le parsing
                valeurNettoyee = valeurNettoyee.replace(/[^\d.,-]/g, '').replace(',', '.');
                let montantBrut = parseFloat(valeurNettoyee);
                
                // Si la valeur est déjà un nombre, l'utiliser directement
                if (typeof value === 'number' && !isNaN(value)) {
                    montantBrut = value;
                }
                
                if (!isNaN(montantBrut)) {
                    // Arrondir précisément à 2 décimales en multipliant par 100, arrondir, puis diviser
                    // Utiliser Math.round pour éviter les erreurs de précision des nombres à virgule flottante
                    // Ajouter un petit epsilon pour éviter les problèmes d'arrondi vers le bas
                    const epsilon = 0.0000001;
                    const montantArrondi = Math.round((montantBrut + epsilon) * 100) / 100;
                    // S'assurer que le résultat est exactement à 2 décimales en utilisant toFixed puis parseFloat
                    const montantFinal = parseFloat(montantArrondi.toFixed(2));
                    section.data[field] = montantFinal;
                    
                    // Forcer la mise à jour du modèle Angular
                    this.cdr.detectChanges();
                    
                    console.log(`💰 [updateSectionData] Montant arrondi: ${montantBrut} -> ${montantArrondi} -> ${montantFinal}`);
                    this.emitResteAPayerCalcule();
                } else {
                    section.data[field] = value;
                }
            } else {
                // Pour tous les autres champs, y compris soldeType
                section.data[field] = value;
                
                // Log spécifique pour soldeType pour le débogage
                if (field === 'soldeType') {
                    console.log(`🔵 [updateSectionData] soldeType mis à jour pour la section #${sectionId}:`, value);
                    console.log(`🔵 [updateSectionData] section.data après mise à jour:`, JSON.stringify(section.data, null, 2));
                    // Forcer la mise à jour du modèle Angular
                    this.cdr.detectChanges();
                }
            }
        }
    }

    // Créer le paiement
    createPaiement(): void {
        console.log('🚀 [createPaiement] Début de la création du paiement');
        console.log('📋 [createPaiement] documentId:', this.documentId);
        console.log('📋 [createPaiement] clientId (document):', this.clientId, '(type:', typeof this.clientId, ')');
        console.log('📋 [createPaiement] montantTotal:', this.montantTotal);
        console.log('📋 [createPaiement] timbreFiscal:', this.timbreFiscal);
        console.log('📋 [createPaiement] nombre de sections:', this.allSections.length);
        console.log('📋 [createPaiement] existingPaiementId AVANT vérification:', this.existingPaiementId);

        if (!this.documentId) {
            console.error('❌ [createPaiement] ID du document manquant');
            this.toastr.error('ID du document manquant', 'Erreur');
            return;
        }

        if (this.allSections.length === 0) {
            console.error('❌ [createPaiement] Aucune section de paiement trouvée');
            this.toastr.error('Veuillez ajouter au moins un type de paiement', 'Erreur');
            return;
        }

        // Récupérer l'utilisateur actuel
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const userId = currentUser?.id;
        const stationId = currentUser?.stations?.[0]?.id;

        console.log('👤 [createPaiement] currentUser:', currentUser);
        console.log('👤 [createPaiement] userId:', userId);
        console.log('👤 [createPaiement] stationId:', stationId);

        if (!userId) {
            console.error('❌ [createPaiement] Utilisateur non connecté');
            this.toastr.error('Utilisateur non connecté', 'Erreur');
            return;
        }

        // IMPORTANT: Vérifier d'abord si un paiement existe AVANT de créer les lignes
        // Pour un avoir : charger par facture d'origine puis filtrer par avoir_id
        const effectiveDocId = this.getDocumentIdForPaiementApi();
        if (!effectiveDocId) {
            this.toastr.error('Document invalide pour le chargement des paiements.', 'Erreur');
            return;
        }
        this.paiementService.getPaiementsByDocumentId(effectiveDocId).subscribe({
            next: (response: any) => {
                // Normaliser la réponse
                let existingPaiements: Paiement[] = [];
                if (Array.isArray(response)) {
                    existingPaiements = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        existingPaiements = response.data;
                    } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
                        existingPaiements = response.data.paiements;
                    } else if (response.data.paiement && typeof response.data.paiement === 'object') {
                        existingPaiements = [response.data.paiement];
                    }
                } else if (response && typeof response === 'object' && response.id) {
                    existingPaiements = [response];
                }
                // Contexte avoir : ne garder que les paiements qui utilisent cet avoir
                if (this.documentType === 'avoir' && this.documentId != null) {
                    existingPaiements = existingPaiements.filter(p => p.avoir_id != null && Number(p.avoir_id) === Number(this.documentId));
                }

                // Définir existingPaiementId si un paiement existe
                if (existingPaiements.length > 0) {
                    existingPaiements.sort((a, b) => {
                        const idA = a.id || 0;
                        const idB = b.id || 0;
                        if (idB !== idA) {
                            return idB - idA;
                        }
                        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                        return dateB - dateA;
                    });
                    const existingPaiement = existingPaiements[0];
                    if (existingPaiement && existingPaiement.id) {
                        this.existingPaiementId = existingPaiement.id;
                        console.log('✅ [createPaiement] Paiement existant trouvé, existingPaiementId défini:', this.existingPaiementId);
                    }
                } else {
                    this.existingPaiementId = null;
                    console.log('ℹ️ [createPaiement] Aucun paiement existant trouvé');
                }

                // Maintenant créer les lignes avec le bon filtrage
                this.createPaiementWithLignes(userId, stationId, existingPaiements);
            },
            error: (error) => {
                if (error?.status === 404) {
                    this.existingPaiementId = null;
                    console.log('ℹ️ [createPaiement] Aucun paiement trouvé (404)');
                    this.createPaiementWithLignes(currentUser?.id, currentUser?.stations?.[0]?.id, []);
                } else {
                    console.error('❌ [createPaiement] Erreur lors de la vérification:', error);
                    this.toastr.error('Erreur lors de la vérification du paiement', 'Erreur');
                }
            }
        });
    }

    private createPaiementWithLignes(userId: number, stationId: number | undefined, existingPaiements: Paiement[]): void {
        // Si on est en mode mise à jour, ne traiter que les NOUVELLES sections (pas celles chargées depuis le paiement existant)
        const sectionsATraiter = this.existingPaiementId 
            ? this.allSections.filter(s => !s.isExisting) // Seulement les nouvelles sections
            : this.allSections; // Toutes les sections pour un nouveau paiement

        console.log('📋 [createPaiementWithLignes] Mode:', this.existingPaiementId ? 'MISE À JOUR' : 'CRÉATION');
        console.log('📋 [createPaiementWithLignes] existingPaiementId:', this.existingPaiementId);
        console.log('📋 [createPaiementWithLignes] Total sections:', this.allSections.length);
        console.log('📋 [createPaiementWithLignes] Sections existantes:', this.allSections.filter(s => s.isExisting).length);
        console.log('📋 [createPaiementWithLignes] Nouvelles sections:', sectionsATraiter.length);
        console.log('📋 [createPaiementWithLignes] Détail des sections à traiter:');
        sectionsATraiter.forEach((s, i) => {
            console.log(`   [${i + 1}] ID: ${s.id}, Type: ${s.type}, Montant: ${s.data?.montant}, isExisting: ${s.isExisting}`);
        });

        // Uploader les fichiers de toutes les sections avant de créer les lignes
        this.uploadSectionFiles(sectionsATraiter).then((sectionsWithUploadedFiles) => {
            this.createLignesPaiement(sectionsWithUploadedFiles, userId, stationId, existingPaiements);
        }).catch((error) => {
            console.error('❌ [createPaiementWithLignes] Erreur lors de l\'upload des fichiers:', error);
            this.toastr.error('Erreur lors de l\'upload des fichiers', 'Erreur');
        });
    }

    /**
     * Upload les fichiers de toutes les sections
     */
    private uploadSectionFiles(sections: any[]): Promise<any[]> {
        const uploadPromises: Promise<any>[] = [];

        sections.forEach((section) => {
            const fichiers = section.data?.fichiers || [];
            if (fichiers.length > 0) {
                // Uploader tous les fichiers de cette section
                const sectionUploadPromises = fichiers.map((file: File) => {
                    const formData = new FormData();
                    formData.append('file', file);
                    return this.stationService.uploadFile(formData).pipe(
                        map((response: any) => {
                            const filePath = response?.path ? `${this.file_url}${response.path}` : null;
                            return filePath;
                        }),
                        catchError((error) => {
                            console.error(`❌ [uploadSectionFiles] Erreur lors de l'upload du fichier ${file.name}:`, error);
                            return of(null); // Retourner null en cas d'erreur
                        })
                    ).toPromise();
                });

                // Attendre que tous les fichiers de cette section soient uploadés
                uploadPromises.push(
                    Promise.all(sectionUploadPromises).then((uploadedPaths) => {
                        // Filtrer les valeurs null (erreurs)
                        const validPaths = uploadedPaths.filter(path => path !== null);
                        // Stocker les chemins dans section.data.fichiersUploades
                        if (!section.data) {
                            section.data = {};
                        }
                        section.data.fichiersUploades = validPaths.length > 0 ? validPaths : null;
                        console.log(`✅ [uploadSectionFiles] Section #${section.id}: ${validPaths.length} fichier(s) uploadé(s)`);
                        return section;
                    })
                );
            } else {
                // Pas de fichiers pour cette section
                uploadPromises.push(Promise.resolve(section));
            }
        });

        return Promise.all(uploadPromises);
    }

    /**
     * Créer les lignes de paiement après l'upload des fichiers
     */
    private createLignesPaiement(sections: any[], userId: number, stationId: number | undefined, existingPaiements: Paiement[]): void {
        // Calculer le total des montants des lignes
        let totalMontantLignes = 0;
        const lignesPaiement: LignePaiement[] = [];

        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            const data = section.data || {};
            // Utiliser une méthode précise pour arrondir à 2 décimales sans erreur d'arrondi
            let montantBrut = 0;
            
            // Si le montant est déjà un nombre, l'utiliser directement
            if (typeof data.montant === 'number') {
                montantBrut = data.montant;
            } else {
                // Sinon, parser la valeur string
                montantBrut = parseFloat(data.montant || '0');
            }
            
            // Arrondir précisément à 2 décimales en multipliant par 100, arrondir, puis diviser
            // Ajouter un petit epsilon pour éviter les problèmes d'arrondi vers le bas
            const epsilon = 0.0000001;
            const montantArrondi = Math.round((montantBrut + epsilon) * 100) / 100;
            // S'assurer que le résultat est exactement à 2 décimales en utilisant toFixed puis parseFloat
            const montant = parseFloat(montantArrondi.toFixed(2));

            if (montant <= 0) {
                console.error(`❌ [createPaiement] Le montant de la section #${section.id} est invalide:`, montant);
                this.toastr.error(`Le montant de la section #${section.id} est invalide`, 'Erreur');
                return;
            }

            totalMontantLignes += montant;
            const montantFormate = montant.toFixed(2);

            // Section Avoir : ligne minimale (uniquement montant)
            if (section.type === 'avoir') {
                const ligne: LignePaiement = {
                    type_paiement: 'avoir',
                    montant: montantFormate,
                    statut: 'en_attente',
                    _sectionIndex: i
                } as any;
                lignesPaiement.push(ligne);
                continue;
            }

            // Récupérer le soldeType depuis section.data (sections espece, cheque, virement, traite)
            let soldeTypeFinal: string = 'secondaire';
            if (section.data && section.data.soldeType) {
                soldeTypeFinal = String(section.data.soldeType);
                console.log(`✅ [createPaiement] Section #${section.id}: soldeType="${soldeTypeFinal}"`);
            }
            data.soldeType = soldeTypeFinal;
            if (section.data) {
                section.data.soldeType = soldeTypeFinal;
            }
            console.log(`📦 [createPaiement] Section #${section.id} (${section.type}):`, { index: i, soldeTypeFinal, montant });

            const ligne: LignePaiement = {
                type_paiement: section.type,
                montant: montantFormate,
                date_reglement: data.date_reglement || null,
                solde_primaire: data.solde_primaire || '0.00',
                solde_secondaire: data.solde_secondaire || '0.00',
                soldeType: (data.soldeType || soldeTypeFinal || 'secondaire') as 'primaire' | 'secondaire',
                porteur: data.porteur || null,
                banque_id: data.banque_id || null,
                numero_cheque: data.numero_cheque || null,
                informations_virement: data.informations_virement || null,
                compte_bancaire_id: data.compte_bancaire_id || null,
                compte_source: data.compte_source || null,
                numero_traite: data.numero_traite || null,
                date_echeance: data.date_echeance || null,
                fichier: this.formatFichierField(data.fichiersUploades),
                statut: 'en_attente',
                _sectionIndex: i
            } as any;
            console.log(`📋 [createPaiement] Ligne créée avec soldeType:`, ligne.soldeType);
            lignesPaiement.push(ligne);
        }

        console.log('💰 [createPaiement] Nombre de lignes créées:', lignesPaiement.length);
        console.log('💰 [createPaiement] totalMontantLignes:', totalMontantLignes);
        console.log('💰 [createPaiement] netAPayer:', this.netAPayer);
        console.log('💰 [createPaiement] montantRetenue:', this.montantRetenue);
        console.log('💰 [createPaiement] montantTTC:', this.montantTTC);

        // Calculer les paiements non affectés si le montant total < net à payer
        const paiementsNonAffectes: PaiementNonAffecte[] = [];
        const difference = this.netAPayer - totalMontantLignes;

        if (difference > 0.01) {
            // Le montant total est inférieur au net à payer, créer un paiement non affecté
            console.log('📋 [createPaiement] Montant total < net à payer, création d\'un paiement non affecté');
            console.log('📋 [createPaiement] Différence:', difference.toFixed(2), 'TND');

            // Déterminer le type de paiement à partir de la première ligne (ou par défaut "cheque")
            const premierType = lignesPaiement.length > 0 ? lignesPaiement[0].type_paiement : 'cheque';
            const numeroReference = lignesPaiement.length > 0
                ? (lignesPaiement[0].numero_cheque || lignesPaiement[0].numero_traite || lignesPaiement[0].informations_virement || `RESTE-${Date.now()}`)
                : `RESTE-${Date.now()}`;

            // S'assurer que le montant est formaté avec exactement 2 décimales
            const montantFormate = parseFloat(difference.toFixed(2)).toFixed(2);

            console.log('📋 [createPaiement] Paiement non affecté — this.clientId:', this.clientId, '(type:', typeof this.clientId, ')');
            const paiementNonAffecte: PaiementNonAffecte = {
                document_id: this.documentId || undefined,
                client_id: this.clientId ?? null,
                date: new Date().toISOString().split('T')[0],
                type: premierType,
                numero: numeroReference,
                montant: montantFormate,
                reference: `RESTE-${Date.now()}`,
                action: 'vide'
            };

            paiementsNonAffectes.push(paiementNonAffecte);
            console.log('✅ [createPaiement] Paiement non affecté créé:', paiementNonAffecte);
            console.log('💰 [createPaiement] Montant du paiement non affecté (formaté):', montantFormate, 'TND');
        } else if (Math.abs(difference) < 0.01) {
            console.log('✅ [createPaiement] Montant total = net à payer, aucun paiement non affecté nécessaire');
        } else {
            console.warn(`⚠️ [createPaiement] Le total des paiements (${totalMontantLignes.toFixed(2)}) dépasse le net à payer (${this.netAPayer.toFixed(2)})`);
            this.toastr.warning(`Le total des paiements (${totalMontantLignes.toFixed(2)}) dépasse le net à payer (${this.netAPayer.toFixed(2)})`, 'Avertissement');
        }

        // Calculer le montant du timbre fiscal
        const avecTimbreFiscal = this.timbreSelection === 'oui';
        const montantTimbreFiscal = avecTimbreFiscal ? this.timbreFiscal : 0;
        // Taux_RS est en pourcentage (1, 1.5, 5, 10) - pas besoin de conversion
        const tauxRS = this.valeurRetenue ? this.tauxRS : '0';

        // Déterminer le statut du paiement
        // Si le total des lignes = net à payer, le paiement est complet (paye)
        // Sinon, il est en attente
        const isPaiementComplet = Math.abs(totalMontantLignes - this.netAPayer) < 0.01;
        const statutPaiement = isPaiementComplet ? 'paye' : 'en_attente';
        const statutLigne = isPaiementComplet ? 'valide' : 'en_attente';

        // Mettre à jour le statut des lignes
        lignesPaiement.forEach(ligne => {
            ligne.statut = statutLigne;
        });

        // Utiliser directement existingPaiements passé en paramètre (déjà vérifié dans createPaiement)
        console.log('═══════════════════════════════════════════════════════════');
        console.log('🔍 [createPaiementWithLignes] UTILISATION DES PAIEMENTS EXISTANTS');
        console.log('═══════════════════════════════════════════════════════════');
        console.log('📦 [createPaiementWithLignes] Nombre de paiements existants:', existingPaiements.length);
        console.log('📦 [createPaiementWithLignes] Nombre de lignes créées:', lignesPaiement.length);

        // Vérifier si le tableau est vide
        if (existingPaiements.length === 0) {
            console.log('🆕 [createPaiementWithLignes] ✅ Aucun paiement existant trouvé');
            console.log('🆕 [createPaiementWithLignes] ➡️ Création d\'un nouveau paiement avec POST');
            console.log('═══════════════════════════════════════════════════════════');
            // Réinitialiser l'ID du paiement existant pour un nouveau paiement
            this.existingPaiementId = null;
            this.createNewPaiement(lignesPaiement, paiementsNonAffectes, userId, stationId, statutPaiement, statutLigne, avecTimbreFiscal, tauxRS, montantTimbreFiscal);
        } else {
            // Si plusieurs paiements existent, prendre le plus récent (ID le plus élevé ou date la plus récente)
            let existingPaiement: Paiement | null = null;

            if (existingPaiements.length === 1) {
                existingPaiement = existingPaiements[0];
            } else {
                // Trier par ID décroissant (le plus récent en premier) ou par date de création
                existingPaiements.sort((a, b) => {
                    // Comparer par ID (le plus élevé = le plus récent)
                    const idA = a.id || 0;
                    const idB = b.id || 0;
                    if (idB !== idA) {
                        return idB - idA;
                    }
                    // Si les ID sont égaux, comparer par date de création
                    const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                    const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                    return dateB - dateA;
                });
                existingPaiement = existingPaiements[0];
                console.log('📋 [createPaiementWithLignes] Plusieurs paiements trouvés, sélection du plus récent (ID:', existingPaiement.id, ')');
            }

            // Vérifier que c'est bien un objet Paiement avec un ID
            if (existingPaiement && typeof existingPaiement === 'object' && existingPaiement.id) {
                console.log('✅ [createPaiementWithLignes] ✅ Paiement existant trouvé avec ID:', existingPaiement.id);
                console.log('🔄 [createPaiementWithLignes] ➡️ Utilisation de PUT pour mettre à jour le paiement');
                console.log('🔄 [createPaiementWithLignes] URL PUT: /api/paiements/' + existingPaiement.id);
                console.log('🔄 [createPaiementWithLignes] Les nouvelles lignes seront ajoutées aux lignes existantes');
                console.log('🔄 [createPaiementWithLignes] Nombre de nouvelles lignes:', lignesPaiement.length);
                console.log('═══════════════════════════════════════════════════════════');
                // existingPaiementId est déjà défini dans createPaiement()
                this.updateExistingPaiement(existingPaiement.id, lignesPaiement, paiementsNonAffectes, userId, stationId, statutPaiement, statutLigne, avecTimbreFiscal, tauxRS, montantTimbreFiscal);
            } else {
                console.warn('⚠️ [createPaiementWithLignes] ⚠️ Paiement existant trouvé mais sans ID valide');
                console.warn('⚠️ [createPaiementWithLignes] Structure complète:', existingPaiement);
                console.log('🆕 [createPaiementWithLignes] ➡️ Création d\'un nouveau paiement avec POST');
                console.log('═══════════════════════════════════════════════════════════');
                this.existingPaiementId = null;
                this.createNewPaiement(lignesPaiement, paiementsNonAffectes, userId, stationId, statutPaiement, statutLigne, avecTimbreFiscal, tauxRS, montantTimbreFiscal);
            }
        }
    }

    private createNewPaiement(
        lignesPaiement: LignePaiement[],
        paiementsNonAffectes: PaiementNonAffecte[],
        userId: number,
        stationId: number | undefined,
        statutPaiement: string,
        statutLigne: string,
        avecTimbreFiscal: boolean,
        tauxRS: string,
        montantTimbreFiscal: number
    ): void {
        // Générer une référence pour le paiement (format: PAY-XXXX)
        const reference = `PAY-${String(Date.now()).slice(-4)}`;

        // Le paiement est toujours attaché à la facture (document payé) ; avoir_id indique l'avoir utilisé.
        // Quand on ouvre depuis un document avoir : document_id = facture d'origine, sinon = documentId (facture).
        const documentIdPourPayload =
            (this.documentType === 'avoir' && this.factureIdForAvoir != null)
                ? this.factureIdForAvoir
                : (this.documentId ?? null);
        if (documentIdPourPayload == null) {
            this.toastr.error('Document invalide pour la création du paiement.', 'Erreur');
            return;
        }

        // Créer l'objet paiement selon le nouveau modèle (client_id = client du document)
        const paiement: Paiement = {
            document_id: documentIdPourPayload,
            client_id: this.clientId ?? null,
            date_paiement: new Date().toISOString(),
            reference: reference,
            montant_total: this.montantTotal.toFixed(2),
            montant_ttc: this.montantTTC.toFixed(2),
            net_a_payer: this.netAPayer.toFixed(2),
            retenue_source: this.valeurRetenue,
            Montant_RS: this.montantRetenue.toFixed(2),
            avec_timbre_fiscal: avecTimbreFiscal,
            Taux_RS: tauxRS,
            montant_timbre_fiscal: montantTimbreFiscal.toFixed(2),
            user_id: userId,
            station_id: stationId || null,
            statut: statutPaiement,
            avoir_id: this.getAvoirIdForPaiement(),
            type: this.shouldShowSectionAvoir() ? 'avoir' : 'facture',
            lignes_paiement: lignesPaiement,
            paiements_non_affectes: paiementsNonAffectes.length > 0 ? paiementsNonAffectes : undefined
        };

        console.log('═══════════════════════════════════════════════════════════');
        console.log('📤 [createNewPaiement] REQUÊTE POST - CRÉATION D\'UN NOUVEAU PAIEMENT');
        console.log('═══════════════════════════════════════════════════════════');
        console.log('📤 [createNewPaiement] REQUÊTE ENVOYÉE (body complet):', JSON.stringify(paiement, null, 2));
        console.log('📤 [createNewPaiement] client_id dans paiement:', paiement.client_id);
        if (paiement.paiements_non_affectes && paiement.paiements_non_affectes.length > 0) {
            console.log('📤 [createNewPaiement] paiements_non_affectes[0].client_id:', paiement.paiements_non_affectes[0].client_id);
        }
        this.logPaiementDetails(paiement);

        // ⚠️ IMPORTANT: La création d'un paiement ne doit PAS modifier le statut du document
        // Le statut du document doit rester inchangé lors de la création d'un paiement
        console.log('⚠️ [createNewPaiement] ATTENTION: Le statut du document ne doit PAS être modifié lors de la création du paiement');
        console.log('⚠️ [createNewPaiement] Document ID:', this.documentId);
        console.log('⚠️ [createNewPaiement] Si le statut change, c\'est probablement le backend qui le modifie automatiquement');

        // Appeler l'API pour créer le paiement
        this.paiementService.createPaiement(paiement).subscribe({
            next: (response: any) => {
                console.log('═══════════════════════════════════════════════════════════');
                console.log('✅ [createNewPaiement] RÉPONSE DE L\'API REÇUE');
                console.log('═══════════════════════════════════════════════════════════');
                console.log('📦 [createNewPaiement] Réponse brute:', response);
                console.log('📦 [createNewPaiement] Réponse JSON:', JSON.stringify(response, null, 2));
                console.log('⚠️ [createNewPaiement] VÉRIFICATION: Le statut du document ne devrait PAS avoir changé');

                // Extraire le paiement de la réponse encapsulée
                let createdPaiement: Paiement;
                if (response && response.data && response.data.paiement) {
                    createdPaiement = response.data.paiement;
                } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                    createdPaiement = response.data[0];
                } else if (response && response.id) {
                    createdPaiement = response;
                } else {
                    console.error('❌ [createNewPaiement] Format de réponse inattendu');
                    this.toastr.error('Format de réponse inattendu du serveur', 'Erreur');
                    return;
                }

                console.log('✅ [createNewPaiement] PAIEMENT CRÉÉ AVEC SUCCÈS');
                console.log('═══════════════════════════════════════════════════════════');
                this.logPaiementResponse(createdPaiement);
                
                // Créer les opérations de trésorerie pour chaque ligne de paiement (uniquement espece et virement)
                this.createTresorerieOperations(createdPaiement, lignesPaiement);
                
                // Créer les lignes chequetraite pour les types cheque et traite
                this.createChequeTraiteOperations(createdPaiement, lignesPaiement);

                const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
                const stationIdForStatut = currentUser?.stations?.[0]?.id;

                const emitPaiementCreatedAndReset = (avoirStatutId?: number, avoirStatutLabel?: string): void => {
                    this.toastr.success('Paiement créé avec succès', 'Succès');
                    if (avoirStatutId != null) {
                        this.paiementCreated.emit({ paiement: createdPaiement, avoirStatutId, avoirStatutLabel: avoirStatutLabel ?? 'Utilisé' });
                    } else {
                        this.paiementCreated.emit(createdPaiement);
                    }
                    this.resetForm(true); // skipResteEmit pour éviter NG0100
                };

                // Paiement avec avoir : récupérer l'id du statut via l'API (statut-documents) puis mettre l'avoir en "Utilisé"
                const getAvoirDocIdAndMontant = (): { avoirDocId: number | null; avoirMontant: number } => {
                    if (this.avoirPourPaiement) {
                        const id = this.getDocumentIdFromAvoir(this.avoirPourPaiement);
                        return { avoirDocId: id, avoirMontant: this.getMontantAvoir(this.avoirPourPaiement) };
                    }
                    if (this.documentType === 'avoir' && this.documentId != null) {
                        return { avoirDocId: this.documentId, avoirMontant: this.montantTotal };
                    }
                    return { avoirDocId: null, avoirMontant: 0 };
                };

                const { avoirDocId, avoirMontant } = getAvoirDocIdAndMontant();
                this.avoirPourPaiement = null;

                if (avoirDocId != null && stationIdForStatut != null) {
                    let totalPayeAvoir = 0;
                    lignesPaiement.forEach(l => { totalPayeAvoir += parseFloat(l.montant || '0'); });
                    const tolerance = 0.01;
                    const estTotalementUtilise = totalPayeAvoir >= avoirMontant - tolerance;
                    // Récupérer les ids des statuts "Utilisé" / "Partiellement utilisé" depuis l'API (GET statut-documents)
                    this.documentService.getStatutIdsAvoir().subscribe({
                        next: (ids) => {
                            const statutIdAvoir = estTotalementUtilise ? ids.utiliseId : ids.partiellementUtiliseId;
                            if (statutIdAvoir == null) {
                                emitPaiementCreatedAndReset();
                                return;
                            }
                            const payload = { statut_id: statutIdAvoir, station_id: Number(stationIdForStatut) };
                            console.log('🔄 [createNewPaiement] Mise à jour statut avoir (id depuis API):', { document_id: avoirDocId, statut_id: statutIdAvoir, payload });
                            const label = estTotalementUtilise ? 'Utilisé' : 'Partiellement utilisé';
                            this.documentService.updateStatut(avoirDocId, payload).subscribe({
                                next: () => {
                                    this.toastr.success(estTotalementUtilise ? 'Avoir marqué comme utilisé' : 'Avoir marqué comme partiellement utilisé', 'Succès', { timeOut: 2000 });
                                    emitPaiementCreatedAndReset(statutIdAvoir, label);
                                },
                                error: (err) => {
                                    console.error('❌ [createNewPaiement] Erreur updateStatut avoir:', err);
                                    this.toastr.warning('Paiement enregistré mais erreur lors de la mise à jour du statut de l\'avoir', 'Attention');
                                    emitPaiementCreatedAndReset(statutIdAvoir, label);
                                }
                            });
                        },
                        error: () => {
                            const fallback = estTotalementUtilise ? 18 : 20;
                            const label = estTotalementUtilise ? 'Utilisé' : 'Partiellement utilisé';
                            const payload = { statut_id: fallback, station_id: Number(stationIdForStatut) };
                            this.documentService.updateStatut(avoirDocId, payload).subscribe({
                                next: () => { this.toastr.success('Avoir marqué comme utilisé', 'Succès', { timeOut: 2000 }); emitPaiementCreatedAndReset(fallback, label); },
                                error: (err) => { console.error('❌ updateStatut avoir:', err); emitPaiementCreatedAndReset(fallback, label); }
                            });
                        }
                    });
                } else {
                    if (avoirDocId != null && stationIdForStatut == null) {
                        this.toastr.warning('Paiement enregistré mais station manquante : impossible de mettre à jour le statut de l\'avoir', 'Attention');
                    }
                    if (avoirDocId == null && (this.documentType === 'avoir' || this.shouldShowSectionAvoir())) {
                        emitPaiementCreatedAndReset();
                    } else if (avoirDocId == null) {
                        this.updateDocumentStatusAfterPaiement(createdPaiement, lignesPaiement);
                        emitPaiementCreatedAndReset();
                    }
                    if (avoirDocId != null) {
                        emitPaiementCreatedAndReset();
                    }
                }
            },
            error: (error) => {
                console.error('═══════════════════════════════════════════════════════════');
                console.error('❌ [createNewPaiement] ERREUR LORS DE LA CRÉATION DU PAIEMENT');
                console.error('═══════════════════════════════════════════════════════════');
                console.error('❌ [createNewPaiement] Status HTTP:', error?.status);
                console.error('❌ [createNewPaiement] Message:', error?.message);
                console.error('❌ [createNewPaiement] Error body:', error?.error);
                console.error('═══════════════════════════════════════════════════════════');
                this.toastr.error('Erreur lors de la création du paiement', 'Erreur');
            }
        });
    }

    private updateExistingPaiement(
        paiementId: number,
        lignesPaiement: LignePaiement[],
        paiementsNonAffectes: PaiementNonAffecte[],
        userId: number,
        stationId: number | undefined,
        statutPaiement: string,
        statutLigne: string,
        avecTimbreFiscal: boolean,
        tauxRS: string,
        montantTimbreFiscal: number
    ): void {
        // Récupérer d'abord le paiement existant pour préserver certaines données
        console.log('📥 [updateExistingPaiement] Récupération du paiement existant ID:', paiementId);
        this.paiementService.getPaiementById(paiementId).subscribe({
            next: (response: any) => {
                console.log('📦 [updateExistingPaiement] Réponse brute de getPaiementById:', response);

                // Extraire le paiement de la réponse encapsulée
                let existingPaiement: Paiement;
                if (response && response.data && response.data.paiement) {
                    existingPaiement = response.data.paiement;
                } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                    existingPaiement = response.data[0];
                } else if (response && response.id) {
                    existingPaiement = response;
                } else {
                    console.error('❌ [updateExistingPaiement] Format de réponse inattendu pour getPaiementById');
                    this.toastr.error('Erreur lors de la récupération du paiement existant', 'Erreur');
                    return;
                }

                console.log('📦 [updateExistingPaiement] Paiement existant extrait:', existingPaiement);
                console.log('📦 [updateExistingPaiement] ID du paiement:', existingPaiement.id);
                console.log('📦 [updateExistingPaiement] Lignes existantes:', existingPaiement.lignes_paiement?.length || 0);
                console.log('📦 [updateExistingPaiement] Nouvelles lignes à ajouter:', lignesPaiement.length);

                // Fusionner les lignes existantes avec les nouvelles lignes
                const existingLignes = existingPaiement.lignes_paiement || [];
                console.log('📋 [updateExistingPaiement] Détail des lignes existantes:');
                existingLignes.forEach((ligne, index) => {
                    console.log(`   [${index + 1}] ID: ${ligne.id}, Type: ${ligne.type_paiement}, Montant: ${ligne.montant}`);
                });

                console.log('📋 [updateExistingPaiement] Détail des nouvelles lignes à ajouter:');
                lignesPaiement.forEach((ligne, index) => {
                    console.log(`   [${index + 1}] ID: ${ligne.id || 'NOUVEAU'}, Type: ${ligne.type_paiement}, Montant: ${ligne.montant}`);
                });

                // S'assurer que les nouvelles lignes n'ont pas d'ID (elles seront créées par le backend)
                const nouvellesLignesSansId = lignesPaiement.map(ligne => {
                    const nouvelleLigne = { ...ligne };
                    // Supprimer l'ID si présent pour indiquer que c'est une nouvelle ligne
                    delete nouvelleLigne.id;
                    delete nouvelleLigne.paiement_id;
                    return nouvelleLigne;
                });

                // Fusionner : lignes existantes (avec ID) + nouvelles lignes (sans ID)
                const allLignesPaiement: LignePaiement[] = [...existingLignes, ...nouvellesLignesSansId];

                console.log('📦 [updateExistingPaiement] Total des lignes après fusion:', allLignesPaiement.length);
                console.log('📋 [updateExistingPaiement] Détail de toutes les lignes (existantes + nouvelles):');
                allLignesPaiement.forEach((ligne, index) => {
                    console.log(`   [${index + 1}] ID: ${ligne.id || 'NOUVEAU'}, Type: ${ligne.type_paiement}, Montant: ${ligne.montant}`);
                });

                // Recalculer le total des montants de toutes les lignes
                let totalMontantToutesLignes = 0;
                allLignesPaiement.forEach(ligne => {
                    totalMontantToutesLignes += parseFloat(ligne.montant || '0');
                });

                console.log('💰 [updateExistingPaiement] Total montant toutes lignes:', totalMontantToutesLignes);
                console.log('💰 [updateExistingPaiement] Net à payer:', this.netAPayer);

                // Recalculer les paiements non affectés avec le nouveau total
                const newPaiementsNonAffectes: PaiementNonAffecte[] = [];
                const difference = this.netAPayer - totalMontantToutesLignes;

                if (difference > 0.01) {
                    // Le montant total est inférieur au net à payer, créer un paiement non affecté
                    console.log('📋 [updateExistingPaiement] Recalcul paiements non affectés - Différence:', difference);
                    const premierType = allLignesPaiement.length > 0 ? allLignesPaiement[0].type_paiement : 'cheque';
                    const numeroReference = allLignesPaiement.length > 0
                        ? (allLignesPaiement[0].numero_cheque || allLignesPaiement[0].numero_traite || allLignesPaiement[0].informations_virement || `RESTE-${Date.now()}`)
                        : `RESTE-${Date.now()}`;

                    // S'assurer que le montant est formaté avec exactement 2 décimales
                    const montantFormate = parseFloat(difference.toFixed(2)).toFixed(2);

                    const paiementNonAffecte: PaiementNonAffecte = {
                        document_id: this.documentId || undefined,
                        client_id: this.clientId ?? null,
                        date: new Date().toISOString().split('T')[0],
                        type: premierType,
                        numero: numeroReference,
                        montant: montantFormate,
                        reference: `RESTE-${Date.now()}`,
                        action: 'vide'
                    };

                    newPaiementsNonAffectes.push(paiementNonAffecte);
                    console.log('💰 [updateExistingPaiement] Montant du paiement non affecté (formaté):', montantFormate, 'TND');
                }

                // Préserver document_id du paiement existant ; si avoir : facture d'origine, sinon documentId
                const documentIdUpdate =
                    existingPaiement.document_id
                    ?? (this.documentType === 'avoir' && this.factureIdForAvoir != null ? this.factureIdForAvoir : this.documentId)!;

                // Créer l'objet paiement pour la mise à jour en fusionnant les lignes
                const paiement: Paiement = {
                    id: paiementId,
                    document_id: documentIdUpdate,
                    client_id: existingPaiement.client_id ?? this.clientId ?? null,
                    date_paiement: existingPaiement.date_paiement || new Date().toISOString(), // Préserver la date originale
                    reference: existingPaiement.reference || `PAY-${String(Date.now()).slice(-4)}`, // Préserver la référence existante
                    montant_total: this.montantTotal.toFixed(2),
                    montant_ttc: this.montantTTC.toFixed(2),
                    net_a_payer: this.netAPayer.toFixed(2),
                    retenue_source: this.valeurRetenue,
                    Montant_RS: this.montantRetenue.toFixed(2),
                    avec_timbre_fiscal: avecTimbreFiscal,
                    Taux_RS: tauxRS,
                    montant_timbre_fiscal: montantTimbreFiscal.toFixed(2),
                    user_id: userId,
                    station_id: stationId || existingPaiement.station_id || null,
                    statut: statutPaiement,
                    avoir_id: existingPaiement.avoir_id ?? this.getAvoirIdForPaiement(),
                    type: existingPaiement.type || 'facture',
                    lignes_paiement: allLignesPaiement, // Toutes les lignes (existantes + nouvelles)
                    paiements_non_affectes: newPaiementsNonAffectes.length > 0 ? newPaiementsNonAffectes : undefined
                };

                console.log('═══════════════════════════════════════════════════════════');
                console.log('📤 [updateExistingPaiement] REQUÊTE PUT - MISE À JOUR DU PAIEMENT');
                console.log('═══════════════════════════════════════════════════════════');
                console.log('🆔 [updateExistingPaiement] ID du paiement à mettre à jour:', paiementId);
                this.logPaiementDetails(paiement);

                // ⚠️ IMPORTANT: La mise à jour d'un paiement ne doit PAS modifier le statut du document
                // Le statut du document doit rester inchangé lors de la mise à jour d'un paiement
                console.log('⚠️ [updateExistingPaiement] ATTENTION: Le statut du document ne doit PAS être modifié lors de la mise à jour du paiement');
                console.log('⚠️ [updateExistingPaiement] Document ID:', this.documentId);
                console.log('⚠️ [updateExistingPaiement] Si le statut change, c\'est probablement le backend qui le modifie automatiquement');

                // Appeler l'API pour mettre à jour le paiement
                this.paiementService.updatePaiement(paiementId, paiement).subscribe({
                    next: (response: any) => {
                        console.log('═══════════════════════════════════════════════════════════');
                        console.log('✅ [updateExistingPaiement] RÉPONSE DE L\'API REÇUE');
                        console.log('═══════════════════════════════════════════════════════════');
                        console.log('📦 [updateExistingPaiement] Réponse brute:', response);
                        console.log('📦 [updateExistingPaiement] Réponse JSON:', JSON.stringify(response, null, 2));
                        console.log('⚠️ [updateExistingPaiement] VÉRIFICATION: Le statut du document ne devrait PAS avoir changé');

                        // Extraire le paiement de la réponse encapsulée
                        let updatedPaiement: Paiement;
                        if (response && response.data && response.data.paiement) {
                            updatedPaiement = response.data.paiement;
                        } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                            updatedPaiement = response.data[0];
                        } else if (response && response.id) {
                            updatedPaiement = response;
                        } else {
                            console.error('❌ [updateExistingPaiement] Format de réponse inattendu');
                            this.toastr.error('Format de réponse inattendu du serveur', 'Erreur');
                            return;
                        }

                        console.log('✅ [updateExistingPaiement] PAIEMENT MIS À JOUR AVEC SUCCÈS');
                        console.log('═══════════════════════════════════════════════════════════');
                        this.logPaiementResponse(updatedPaiement);
                        
                        // Créer les opérations de trésorerie pour les nouvelles lignes de paiement uniquement (uniquement espece et virement)
                        this.createTresorerieOperations(updatedPaiement, lignesPaiement);
                        
                        // Créer les lignes chequetraite pour les types cheque et traite
                        this.createChequeTraiteOperations(updatedPaiement, lignesPaiement);
                        
                        // Mettre à jour le statut du document selon le montant payé
                        this.updateDocumentStatusAfterPaiement(updatedPaiement, allLignesPaiement);
                        
                        this.toastr.success('Paiement mis à jour avec succès', 'Succès');
                        this.paiementCreated.emit(updatedPaiement);
                        this.resetForm(true);
                    },
                    error: (error) => {
                        console.error('═══════════════════════════════════════════════════════════');
                        console.error('❌ [updateExistingPaiement] ERREUR LORS DE LA MISE À JOUR DU PAIEMENT');
                        console.error('═══════════════════════════════════════════════════════════');
                        console.error('❌ [updateExistingPaiement] Status HTTP:', error?.status);
                        console.error('❌ [updateExistingPaiement] Message:', error?.message);
                        console.error('❌ [updateExistingPaiement] Error body:', error?.error);
                        console.error('═══════════════════════════════════════════════════════════');
                        this.toastr.error('Erreur lors de la mise à jour du paiement', 'Erreur');
                    }
                });
            },
            error: (error) => {
                console.error('❌ [updateExistingPaiement] Erreur lors de la récupération du paiement existant:', error);
                // Si on ne peut pas récupérer le paiement, créer quand même l'objet de mise à jour
                const paiement: Paiement = {
                    id: paiementId,
                    document_id: this.documentId!,
                    client_id: this.clientId ?? null,
                    date_paiement: new Date().toISOString(),
                    montant_total: this.montantTotal.toFixed(2),
                    montant_ttc: this.montantTTC.toFixed(2),
                    net_a_payer: this.netAPayer.toFixed(2),
                    retenue_source: this.valeurRetenue,
                    Montant_RS: this.montantRetenue.toFixed(2),
                    avec_timbre_fiscal: avecTimbreFiscal,
                    Taux_RS: tauxRS,
                    montant_timbre_fiscal: montantTimbreFiscal.toFixed(2),
                    user_id: userId,
                    station_id: stationId || null,
                    statut: statutPaiement,
                    avoir_id: null,
                    type: 'facture',
                    lignes_paiement: lignesPaiement,
                    paiements_non_affectes: paiementsNonAffectes.length > 0 ? paiementsNonAffectes : undefined
                };

                this.paiementService.updatePaiement(paiementId, paiement).subscribe({
                    next: (response: any) => {
                        // Extraire le paiement de la réponse encapsulée
                        let updatedPaiement: Paiement;
                        if (response && response.data && response.data.paiement) {
                            updatedPaiement = response.data.paiement;
                        } else if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                            updatedPaiement = response.data[0];
                        } else if (response && response.id) {
                            updatedPaiement = response;
                        } else {
                            console.error('❌ [updateExistingPaiement] Format de réponse inattendu');
                            this.toastr.error('Format de réponse inattendu du serveur', 'Erreur');
                            return;
                        }

                        console.log('✅ [updateExistingPaiement] Paiement mis à jour avec succès');
                        
                        // Créer les opérations de trésorerie pour les nouvelles lignes de paiement uniquement (uniquement espece et virement)
                        this.createTresorerieOperations(updatedPaiement, lignesPaiement);
                        
                        // Créer les lignes chequetraite pour les types cheque et traite
                        this.createChequeTraiteOperations(updatedPaiement, lignesPaiement);
                        
                        // Mettre à jour le statut du document selon le montant payé
                        this.updateDocumentStatusAfterPaiement(updatedPaiement, lignesPaiement);
                        
                        this.toastr.success('Paiement mis à jour avec succès', 'Succès');
                        this.paiementCreated.emit(updatedPaiement);
                        this.resetForm(true);
                    },
                    error: (updateError) => {
                        console.error('❌ [updateExistingPaiement] Erreur lors de la mise à jour:', updateError);
                        this.toastr.error('Erreur lors de la mise à jour du paiement', 'Erreur');
                    }
                });
            }
        });
    }

    private logPaiementDetails(paiement: Paiement): void {
        console.log(JSON.stringify(paiement, null, 2));
        console.log('───────────────────────────────────────────────────────────');
        console.log('📋 DÉTAILS DU PAIEMENT:');
        console.log('   📄 document_id:', paiement.document_id);
        console.log('   📅 date_paiement:', paiement.date_paiement);
        console.log('   🔖 reference:', paiement.reference);
        console.log('   💰 montant_total:', paiement.montant_total, 'TND');
        console.log('   💰 montant_ttc:', paiement.montant_ttc, 'TND');
        console.log('   💵 net_a_payer:', paiement.net_a_payer, 'TND');
        console.log('   📊 retenue_source:', paiement.retenue_source);
        console.log('   💸 Montant_RS:', paiement.Montant_RS, 'TND');
        console.log('   🎫 avec_timbre_fiscal:', paiement.avec_timbre_fiscal);
        console.log('   📈 Taux_RS:', paiement.Taux_RS, '%');
        console.log('   💰 montant_timbre_fiscal:', paiement.montant_timbre_fiscal, 'TND');
        console.log('   👤 user_id:', paiement.user_id);
        console.log('   🏢 station_id:', paiement.station_id);
        console.log('   ✅ statut:', paiement.statut);
        console.log('   📝 type:', paiement.type);
        console.log('   📦 nombre de lignes_paiement:', paiement.lignes_paiement.length);
        console.log('   📋 lignes_paiement:');
        paiement.lignes_paiement.forEach((ligne, index) => {
            console.log(`      [${index + 1}] ${ligne.type_paiement}: ${ligne.montant} TND (statut: ${ligne.statut})`);
        });
        if (paiement.paiements_non_affectes && paiement.paiements_non_affectes.length > 0) {
            console.log('   ⚠️ nombre de paiements_non_affectes:', paiement.paiements_non_affectes.length);
            console.log('   📋 paiements_non_affectes:');
            paiement.paiements_non_affectes.forEach((pna, index) => {
                console.log(`      [${index + 1}] Type: ${pna.type}, Montant: ${pna.montant} TND, Numéro: ${pna.numero}`);
            });
        } else {
            console.log('   ✅ Aucun paiement non affecté (montant total = net à payer)');
        }
        console.log('═══════════════════════════════════════════════════════════');
    }

    private logPaiementResponse(paiement: Paiement): void {
        console.log('📦 Paiement retourné par le serveur:');
        console.log(JSON.stringify(paiement, null, 2));
        console.log('───────────────────────────────────────────────────────────');
        console.log('📋 DÉTAILS DU PAIEMENT:');
        console.log('   🆔 id:', paiement.id);
        console.log('   📄 document_id:', paiement.document_id);
        console.log('   🔖 reference:', paiement.reference);
        console.log('   📅 date_paiement:', paiement.date_paiement);
        console.log('   💰 montant_total:', paiement.montant_total, 'TND');
        console.log('   💰 montant_ttc:', paiement.montant_ttc, 'TND');
        console.log('   💵 net_a_payer:', paiement.net_a_payer, 'TND');
        console.log('   📊 retenue_source:', paiement.retenue_source);
        console.log('   💸 Montant_RS:', paiement.Montant_RS, 'TND');
        console.log('   🎫 avec_timbre_fiscal:', paiement.avec_timbre_fiscal);
        console.log('   📈 Taux_RS:', paiement.Taux_RS, '%');
        console.log('   💰 montant_timbre_fiscal:', paiement.montant_timbre_fiscal, 'TND');
        console.log('   ✅ statut:', paiement.statut);
        console.log('   📝 type:', paiement.type);
        console.log('   📦 nombre de lignes_paiement:', paiement.lignes_paiement?.length || 0);
        if (paiement.lignes_paiement && paiement.lignes_paiement.length > 0) {
            console.log('   📋 lignes_paiement:');
            paiement.lignes_paiement.forEach((ligne, index) => {
                console.log(`      [${index + 1}] ID: ${ligne.id}, Type: ${ligne.type_paiement}, Montant: ${ligne.montant} TND, Statut: ${ligne.statut}`);
            });
        }
        if (paiement.paiements_non_affectes && paiement.paiements_non_affectes.length > 0) {
            console.log('   ⚠️ nombre de paiements_non_affectes:', paiement.paiements_non_affectes.length);
            console.log('   📋 paiements_non_affectes:');
            paiement.paiements_non_affectes.forEach((pna, index) => {
                console.log(`      [${index + 1}] ID: ${pna.id}, Type: ${pna.type}, Montant: ${pna.montant} TND, Date: ${pna.date}`);
            });
        }
        console.log('═══════════════════════════════════════════════════════════');
    }

    getSectionMontant(sectionId: number): number {
        const section = this.allSections.find(s => s.id === sectionId);
        return section?.data?.montant ? parseFloat(section.data.montant) : 0;
    }

    calculateSectionTotal(sectionId: number): void {
        // Recalculer le total si nécessaire
        this.cdr.detectChanges();
    }

    /**
     * Charger les caisses/soldes depuis l'API (type_solde dynamique)
     * GET /api/tresorerie/soldes/station/:station_id/user/:user_id
     */
    private loadSoldes(): void {
        if (!this.idStation) {
            return;
        }

        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const userId = currentUser?.id != null ? Number(currentUser.id) : null;
        if (!userId) {
            return;
        }

        this.tresorerieService.getSoldesByStationAndUser(this.idStation, userId).subscribe({
            next: (soldes: Solde[]) => {
                const list = soldes || [];
                this.soldesList = list;
                this.soldesByType = list.reduce((acc: Record<string, string>, s: any) => {
                    const key = (s?.type_solde ?? '').toString();
                    if (key) acc[key] = (s?.montant_total ?? '0').toString();
                    return acc;
                }, {});

                // Compat: conserver les deux champs utilisés ailleurs dans le fichier
                const soldePrimaire = list.find((s: any) => s?.type_solde === 'primaire');
                const soldeSecondaire = list.find((s: any) => s?.type_solde === 'secondaire');
                this.currentSoldePrimaire = soldePrimaire?.montant_total ? parseFloat(String(soldePrimaire.montant_total)).toFixed(2) : '0.00';
                this.currentSoldeSecondaire = soldeSecondaire?.montant_total ? parseFloat(String(soldeSecondaire.montant_total)).toFixed(2) : '0.00';

                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error('❌ [loadSoldes] Erreur lors du chargement des soldes:', error);
            }
        });
    }

    /**
     * Charger les banques depuis l'API
     */
    private loadBanques(): void {
        console.log('🏦 [loadBanques] Début du chargement des banques');
        console.log('🏦 [loadBanques] idStation:', this.idStation);

        // Si idStation est disponible, utiliser getBanques(idStation)
        // Sinon, utiliser getAllBanques() comme fallback
        const banquesObservable = this.idStation 
            ? this.banqueService.getBanques(this.idStation)
            : this.banqueService.getAllBanques();

        console.log('🏦 [loadBanques] Méthode utilisée:', this.idStation ? `getBanques(${this.idStation})` : 'getAllBanques()');
        
        banquesObservable.subscribe({
            next: (response: any) => {
                console.log('🏦 [loadBanques] Réponse API banques complète:', response);
                console.log('🏦 [loadBanques] Type de réponse:', typeof response);
                console.log('🏦 [loadBanques] response.banques:', response?.banques);
                console.log('🏦 [loadBanques] response.data:', response?.data);
                
                // Normaliser la réponse selon le format BanqueResponse
                let banquesList: Banque[] = [];
                
                // Format 1: { banques: [...] }
                if (response && response.banques && Array.isArray(response.banques)) {
                    banquesList = response.banques;
                    console.log('✅ [loadBanques] Format détecté: response.banques');
                }
                // Format 2: { data: { banques: [...] } }
                else if (response && response.data && response.data.banques && Array.isArray(response.data.banques)) {
                    banquesList = response.data.banques;
                    console.log('✅ [loadBanques] Format détecté: response.data.banques');
                }
                // Format 3: Array direct
                else if (Array.isArray(response)) {
                    banquesList = response;
                    console.log('✅ [loadBanques] Format détecté: Array direct');
                }
                // Format 4: { data: [...] }
                else if (response && response.data && Array.isArray(response.data)) {
                    banquesList = response.data;
                    console.log('✅ [loadBanques] Format détecté: response.data (array)');
                }
                // Format 5: { success: true, data: { banques: [...] } }
                else if (response && response.success && response.data) {
                    if (Array.isArray(response.data)) {
                        banquesList = response.data;
                    } else if (response.data.banques && Array.isArray(response.data.banques)) {
                        banquesList = response.data.banques;
                    }
                    console.log('✅ [loadBanques] Format détecté: response.success avec data');
                }
                
                console.log('📋 [loadBanques] Nombre de banques avant filtrage:', banquesList.length);
                
                // Filtrer uniquement les banques actives (statut = true)
                this.banques = banquesList.filter((banque: Banque) => {
                    const isActive = banque.statut === true;
                    if (!isActive) {
                        console.log(`⚠️ [loadBanques] Banque "${banque.nom}" (ID: ${banque.id}) filtrée car statut = ${banque.statut}`);
                    }
                    return isActive;
                });
                
                console.log('✅ [loadBanques] Nombre de banques chargées (après filtrage):', this.banques.length);
                if (this.banques.length > 0) {
                    console.log('✅ [loadBanques] Banques chargées:', this.banques.map(b => ({ id: b.id, nom: b.nom, statut: b.statut })));
                } else {
                    console.warn('⚠️ [loadBanques] Aucune banque active trouvée');
                }
                
                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error('❌ [loadBanques] Erreur lors du chargement des banques:', error);
                console.error('❌ [loadBanques] Détails de l\'erreur:', {
                    status: error?.status,
                    statusText: error?.statusText,
                    message: error?.message,
                    error: error?.error,
                    url: error?.url
                });
                this.toastr.error(`Erreur lors du chargement des banques: ${error?.error?.message || error?.message || 'Erreur inconnue'}`, 'Erreur');
            }
        });
    }

    /**
     * Charger les comptes bancaires depuis l'API
     */
    private loadComptesBancaires(): void {
        console.log('🏦 [loadComptesBancaires] Début du chargement des comptes bancaires');
        console.log('🏦 [loadComptesBancaires] idStation:', this.idStation);

        if (!this.idStation) {
            console.warn('⚠️ [loadComptesBancaires] idStation non disponible');
            return;
        }

        this.banqueService.getBanques(this.idStation).subscribe({
            next: (response: any) => {
                console.log('🏦 [loadComptesBancaires] Réponse API comptes bancaires complète:', response);
                
                // Normaliser la réponse selon le format BanqueResponse
                let comptesList: Banque[] = [];
                
                // Format 1: { banques: [...] }
                if (response && response.banques && Array.isArray(response.banques)) {
                    comptesList = response.banques;
                    console.log('✅ [loadComptesBancaires] Format détecté: response.banques');
                }
                // Format 2: { data: { banques: [...] } }
                else if (response && response.data && response.data.banques && Array.isArray(response.data.banques)) {
                    comptesList = response.data.banques;
                    console.log('✅ [loadComptesBancaires] Format détecté: response.data.banques');
                }
                // Format 3: Array direct
                else if (Array.isArray(response)) {
                    comptesList = response;
                    console.log('✅ [loadComptesBancaires] Format détecté: Array direct');
                }
                // Format 4: { data: [...] }
                else if (response && response.data && Array.isArray(response.data)) {
                    comptesList = response.data;
                    console.log('✅ [loadComptesBancaires] Format détecté: response.data (array)');
                }
                // Format 5: { success: true, data: { banques: [...] } }
                else if (response && response.success && response.data) {
                    if (Array.isArray(response.data)) {
                        comptesList = response.data;
                    } else if (response.data.banques && Array.isArray(response.data.banques)) {
                        comptesList = response.data.banques;
                    }
                    console.log('✅ [loadComptesBancaires] Format détecté: response.success avec data');
                }
                
                console.log('📋 [loadComptesBancaires] Nombre de comptes avant filtrage:', comptesList.length);
                
                // Filtrer uniquement les comptes bancaires actifs (statut = true)
                this.comptesBancaires = comptesList.filter((compte: Banque) => {
                    const isActive = compte.statut === true;
                    if (!isActive) {
                        console.log(`⚠️ [loadComptesBancaires] Compte "${compte.nom}" (ID: ${compte.id}) filtré car statut = ${compte.statut}`);
                    }
                    return isActive;
                });
                
                console.log('✅ [loadComptesBancaires] Nombre de comptes bancaires chargés (après filtrage):', this.comptesBancaires.length);
                if (this.comptesBancaires.length > 0) {
                    console.log('✅ [loadComptesBancaires] Comptes bancaires chargés:', this.comptesBancaires.map(c => ({ id: c.id, nom: c.nom, statut: c.statut })));
                } else {
                    console.warn('⚠️ [loadComptesBancaires] Aucun compte bancaire actif trouvé');
                }
                
                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error('❌ [loadComptesBancaires] Erreur lors du chargement des comptes bancaires:', error);
                console.error('❌ [loadComptesBancaires] Détails de l\'erreur:', {
                    status: error?.status,
                    statusText: error?.statusText,
                    message: error?.message,
                    error: error?.error,
                    url: error?.url
                });
                this.comptesBancaires = [];
                this.cdr.detectChanges();
            }
        });
    }

    /**
     * Mettre à jour les montants des soldes dans toutes les sections
     * IMPORTANT: Ne pas mettre à jour les sections existantes car elles doivent conserver
     * les soldes qu'elles avaient au moment de leur création.
     * Cette méthode est utilisée uniquement lors du chargement initial des soldes
     * pour les nouvelles sections qui n'ont pas encore de soldes définis.
     */
    private updateAllSectionsSoldes(): void {
        this.allSections.forEach(section => {
            if (section.data) {
                // Ne mettre à jour que si les soldes ne sont pas encore définis
                // Cela préserve les soldes des sections existantes
                if (!section.data.solde_primaire || section.data.solde_primaire === '0.00') {
                    section.data.solde_primaire = this.currentSoldePrimaire;
                }
                if (!section.data.solde_secondaire || section.data.solde_secondaire === '0.00') {
                    section.data.solde_secondaire = this.currentSoldeSecondaire;
                }
            }
        });
        this.cdr.detectChanges();
    }

    /**
     * Ajouter une section avec les soldes actuels (méthode helper)
     */
    private addSectionWithSoldes(sectionType: 'espece' | 'cheque' | 'virement' | 'traite' | 'avoir', sectionData: any): void {
        // Pour les sections autres qu'avoir, s'assurer que soldeType est initialisé
        if (sectionType !== 'avoir') {
            if (!sectionData.soldeType) {
                sectionData.soldeType = this.soldesList?.[0]?.type_solde || 'secondaire';
            }
            // Attacher les soldes dynamiques (pour affichage dans le HTML)
            sectionData.soldesByType = { ...(this.soldesByType || {}) };

            // Compat: garder les champs historiques primaire/secondaire si la page les utilise encore
            sectionData.solde_primaire = this.currentSoldePrimaire || '0.00';
            sectionData.solde_secondaire = this.currentSoldeSecondaire || '0.00';
        }

        this.fenetre = this.fenetre + 1;
        const sectionId = this.sectionCounter++;

        // Calculer le montant par défaut si non fourni
        if (sectionData.montant === undefined || sectionData.montant === '' || sectionData.montant === null) {
            const montantDefaut = this.calculateMontantDefaut();
            sectionData.montant = montantDefaut;
            console.log(`💰 [addSectionWithSoldes] Montant par défaut calculé pour section #${sectionId}:`, montantDefaut, 'TND (resteAPayer:', this.resteAPayer, ')');
        }
        
        console.log(`📦 [addSectionWithSoldes] Création de section #${sectionId} (${sectionType})`, sectionType === 'avoir' ? '' : `soldeType: ${sectionData.soldeType}`);
        console.log(`💰 [addSectionWithSoldes] Montant final de la section #${sectionId}:`, sectionData.montant);
        
        this.allSections.push({
            id: sectionId,
            type: sectionType,
            isContentVisible: true,
            data: sectionData,
            isExisting: false
        });
        
        const addedSection = this.allSections.find(s => s.id === sectionId);
        if (addedSection && sectionType !== 'avoir') {
            console.log(`✅ [addSectionWithSoldes] Section ajoutée avec soldeType vérifié:`, addedSection.data?.soldeType);
        }
        
        this.emitResteAPayerCalcule();
        this.cdr.markForCheck();
    }

    /** Ajoute une section Avoir lorsque le popup est ouvert pour un document de type Avoir (Non utilisé / Partiellement utilisé). */
    private addSectionAvoirForDocumentAvoir(): void {
        if (this.allSections.some(s => s.type === 'avoir')) {
            return; // Déjà une section Avoir
        }
        const montant = this.getResteAPayerCalcule() > 0 ? this.getResteAPayerCalcule() : (this.resteAPayer > 0 ? this.resteAPayer : this.montantTotal);
        const avoirId = this.documentId;
        this.addSectionWithSoldes('avoir', { montant, avoir_id: avoirId });
        console.log('📋 [addSectionAvoirForDocumentAvoir] Section Avoir ajoutée pour document avoir, montant:', montant, 'TND');
    }

    /** Si le contexte est un avoir (documentType/statut) et qu'il n'y a pas de section Avoir, l'ajouter. Appelé après chargement paiement (0 ou existant). */
    private ensureSectionAvoirIfNeeded(): void {
        if (!this.documentId || !this.shouldShowSectionAvoir()) return;
        if (this.allSections.some(s => s.type === 'avoir')) return;
        this.addSectionAvoirForDocumentAvoir();
        this.cdr.markForCheck();
    }

    /**
     * Charger les soldes et ajouter une section après le chargement
     */
    private loadSoldesAndAddSection(sectionType: 'espece' | 'cheque' | 'virement' | 'traite', sectionData: any): void {
        if (!this.idStation) {
            // Pas de station, ajouter la section avec les valeurs par défaut
            this.addSectionWithSoldes(sectionType, sectionData);
            return;
        }

        this.tresorerieService.getSoldesByStation(this.idStation).subscribe({
            next: (response: any) => {
                // Normaliser la réponse
                let soldes: any[] = [];
                if (Array.isArray(response)) {
                    soldes = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        soldes = response.data;
                    } else if (response.data.soldes && Array.isArray(response.data.soldes)) {
                        soldes = response.data.soldes;
                    } else if (typeof response.data === 'object') {
                        for (const key in response.data) {
                            if (Array.isArray(response.data[key])) {
                                soldes = response.data[key];
                                break;
                            }
                        }
                    }
                } else if (response && response.soldes && Array.isArray(response.soldes)) {
                    soldes = response.soldes;
                } else if (response && response.success && response.data) {
                    soldes = Array.isArray(response.data) ? response.data : [response.data];
                }
                
                const soldePrimaire = soldes.find((s: any) => s.type_solde === 'primaire');
                const soldeSecondaire = soldes.find((s: any) => s.type_solde === 'secondaire');
                
                this.currentSoldePrimaire = soldePrimaire?.montant_total 
                    ? parseFloat(soldePrimaire.montant_total).toFixed(2) 
                    : '0.00';
                this.currentSoldeSecondaire = soldeSecondaire?.montant_total 
                    ? parseFloat(soldeSecondaire.montant_total).toFixed(2) 
                    : '0.00';
                
                // Ajouter la section avec les soldes chargés
                this.addSectionWithSoldes(sectionType, sectionData);
            },
            error: () => {
                // En cas d'erreur, ajouter quand même la section avec les valeurs par défaut
                this.addSectionWithSoldes(sectionType, sectionData);
            }
        });
    }

    /**
     * Vérifier si un paiement existe déjà pour ce document et définir existingPaiementId
     */
    private checkExistingPaiement(): void {
        const effectiveDocId = this.getDocumentIdForPaiementApi();
        if (!effectiveDocId) {
            return;
        }

        this.paiementService.getPaiementsByDocumentId(effectiveDocId).subscribe({
            next: (response: any) => {
                // Normaliser la réponse
                let existingPaiements: Paiement[] = [];
                if (Array.isArray(response)) {
                    existingPaiements = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        existingPaiements = response.data;
                    } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
                        existingPaiements = response.data.paiements;
                    } else if (response.data.paiement && typeof response.data.paiement === 'object') {
                        existingPaiements = [response.data.paiement];
                    }
                } else if (response && typeof response === 'object' && response.id) {
                    existingPaiements = [response];
                }
                if (this.documentType === 'avoir' && this.documentId != null) {
                    existingPaiements = existingPaiements.filter(p => p.avoir_id != null && Number(p.avoir_id) === Number(this.documentId));
                }

                if (existingPaiements.length > 0) {
                    // Trier pour obtenir le plus récent
                    existingPaiements.sort((a, b) => {
                        const idA = a.id || 0;
                        const idB = b.id || 0;
                        if (idB !== idA) {
                            return idB - idA;
                        }
                        const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                        const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                        return dateB - dateA;
                    });
                    
                    const existingPaiement = existingPaiements[0];
                    if (existingPaiement && existingPaiement.id) {
                        this.existingPaiementId = existingPaiement.id;
                        console.log('✅ [checkExistingPaiement] Paiement existant trouvé, existingPaiementId défini:', this.existingPaiementId);
                    }
                } else {
                    this.existingPaiementId = null;
                    console.log('ℹ️ [checkExistingPaiement] Aucun paiement existant trouvé');
                }
            },
            error: (error) => {
                // En cas d'erreur (404), considérer qu'il n'y a pas de paiement existant
                if (error?.status === 404) {
                    this.existingPaiementId = null;
                    console.log('ℹ️ [checkExistingPaiement] Aucun paiement trouvé (404)');
                } else {
                    console.error('❌ [checkExistingPaiement] Erreur lors de la vérification:', error);
                }
            }
        });
    }

    /**
     * Charger le paiement existant pour ce document
     */
    private loadExistingPaiement(): void {
        const effectiveDocId = this.getDocumentIdForPaiementApi();
        if (!effectiveDocId) {
            return;
        }

        console.log('📥 [loadExistingPaiement] Chargement du paiement existant pour documentId (effectif):', effectiveDocId, this.documentType === 'avoir' ? '(avoir, doc=' + this.documentId + ')' : '');

        this.paiementService.getPaiementsByDocumentId(effectiveDocId).subscribe({
            next: (response: any) => {
                console.log('📦 [loadExistingPaiement] Réponse API:', response);

                // Normaliser la réponse
                let existingPaiements: Paiement[] = [];
                if (Array.isArray(response)) {
                    existingPaiements = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        existingPaiements = response.data;
                    } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
                        existingPaiements = response.data.paiements;
                    } else if (response.data.paiement && typeof response.data.paiement === 'object') {
                        existingPaiements = [response.data.paiement];
                    }
                } else if (response && response.id) {
                    existingPaiements = [response];
                }
                if (this.documentType === 'avoir' && this.documentId != null) {
                    existingPaiements = existingPaiements.filter(p => p.avoir_id != null && Number(p.avoir_id) === Number(this.documentId));
                }

                if (existingPaiements.length === 0) {
                    console.log('ℹ️ [loadExistingPaiement] Aucun paiement existant trouvé');
                    // Ouvrir le paiement d'un avoir : afficher la section Avoir (uniquement input montant)
                    // Délai 0 pour s'assurer que documentType/documentStatutId sont bien liés par le parent
                    setTimeout(() => this.ensureSectionAvoirIfNeeded(), 0);
                    return;
                }

                // Prendre le paiement le plus récent
                existingPaiements.sort((a, b) => {
                    const idA = a.id || 0;
                    const idB = b.id || 0;
                    if (idB !== idA) {
                        return idB - idA;
                    }
                    const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                    const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                    return dateB - dateA;
                });

                const existingPaiement = existingPaiements[0];
                console.log('✅ [loadExistingPaiement] Paiement existant trouvé:', existingPaiement);

                if (existingPaiement?.id) {
                    this.existingPaiementId = existingPaiement.id;
                }

                // Charger les données du paiement dans le formulaire
                this.populateFormFromPaiement(existingPaiement);

                // Contexte avoir (Non utilisé / Partiellement utilisé) : s'assurer qu'une section Avoir existe (paiement peut avoir 0 lignes ou pas de ligne avoir)
                this.ensureSectionAvoirIfNeeded();
            },
            error: (error) => {
                console.error('❌ [loadExistingPaiement] Erreur lors du chargement du paiement:', error);
                // Ne pas afficher d'erreur si c'est un 404 (pas de paiement)
                if (error?.status !== 404) {
                    console.warn('⚠️ [loadExistingPaiement] Erreur lors du chargement, formulaire vide');
                }
            }
        });
    }

    /**
     * Pré-remplir le formulaire avec les données du paiement existant
     */
    private populateFormFromPaiement(paiement: Paiement): void {
        console.log('📝 [populateFormFromPaiement] Pré-remplissage du formulaire avec le paiement:', paiement);

        // 1. Retenue à la source
        this.valeurRetenue = paiement.retenue_source || false;
        this.retenueSelection = this.valeurRetenue ? 'oui' : 'non';
        this.montantRetenue = parseFloat(paiement.Montant_RS || '0');

        // 2. Timbre fiscal
        this.timbreSelection = paiement.avec_timbre_fiscal ? 'oui' : 'non';
        
        // 3. Récupérer le taux RS depuis l'API (déjà en pourcentage)
        if (paiement.Taux_RS) {
            // Taux_RS est déjà en pourcentage (1, 1.5, 5, 10)
            // Convertir en chaîne et s'assurer que le format correspond aux valeurs du select
            const tauxRSValue = String(paiement.Taux_RS).trim();
            // Normaliser la valeur pour correspondre aux options du select
            if (tauxRSValue === '1' || tauxRSValue === '1.0' || tauxRSValue === '1.00') {
                this.tauxRS = '1';
            } else if (tauxRSValue === '1.5' || tauxRSValue === '1.50') {
                this.tauxRS = '1.5';
            } else if (tauxRSValue === '5' || tauxRSValue === '5.0' || tauxRSValue === '5.00') {
                this.tauxRS = '5';
            } else if (tauxRSValue === '10' || tauxRSValue === '10.0' || tauxRSValue === '10.00') {
                this.tauxRS = '10';
            } else {
                // Si la valeur ne correspond pas exactement, essayer de la parser
                const tauxNum = parseFloat(tauxRSValue);
                if (!isNaN(tauxNum)) {
                    // Arrondir au taux le plus proche
                    if (Math.abs(tauxNum - 1) < 0.25) {
                        this.tauxRS = '1';
                    } else if (Math.abs(tauxNum - 1.5) < 0.25) {
                        this.tauxRS = '1.5';
                    } else if (Math.abs(tauxNum - 5) < 0.5) {
                        this.tauxRS = '5';
                    } else if (Math.abs(tauxNum - 10) < 0.5) {
                        this.tauxRS = '10';
                    } else {
                        this.tauxRS = '1'; // Par défaut
                    }
                } else {
                    this.tauxRS = '1'; // Par défaut si la valeur n'est pas valide
                }
            }
            console.log('✅ [populateFormFromPaiement] Taux_RS chargé depuis l\'API:', paiement.Taux_RS, '→ tauxRS assigné:', this.tauxRS);
        } else if (this.valeurRetenue && this.montantRetenue > 0) {
            // Calculer le taux de retenue à la source à partir du Montant_RS si Taux_RS n'est pas disponible
            // Déterminer la base de calcul selon si le timbre est inclus
            const sousTotalTTC = parseFloat(paiement.montant_ttc || '0') - this.timbreFiscal;
            const baseRS = paiement.avec_timbre_fiscal 
                ? parseFloat(paiement.montant_ttc || '0')
                : sousTotalTTC;
            
            if (baseRS > 0) {
                // Calculer le taux en pourcentage
                const tauxCalcule = (this.montantRetenue / baseRS) * 100;
                
                // Arrondir au taux le plus proche (1%, 1.5%, 5%, 10%)
                if (Math.abs(tauxCalcule - 1) < 0.5) {
                    this.tauxRS = '1';
                } else if (Math.abs(tauxCalcule - 1.5) < 0.5) {
                    this.tauxRS = '1.5';
                } else if (Math.abs(tauxCalcule - 5) < 0.5) {
                    this.tauxRS = '5';
                } else if (Math.abs(tauxCalcule - 10) < 0.5) {
                    this.tauxRS = '10';
                } else {
                    this.tauxRS = '1'; // Par défaut
                }
            } else {
                this.tauxRS = '1'; // Par défaut
            }
        } else {
            this.tauxRS = '1'; // Par défaut
        }

        // 4. Montants - Charger depuis le paiement
        this.montantTTC = parseFloat(paiement.montant_ttc || '0');
        
        // IMPORTANT: Ne pas charger netAPayer directement depuis le paiement
        // Il sera recalculé par calculateTotals() pour garantir la cohérence
        // Net à payer = Total TTC - Montant RS (toujours appliqué)

        // 5. Recalculer les totaux pour s'assurer que tout est cohérent
        // Cela garantit que netAPayer = montantTTC - montantRetenue
        this.calculateTotals();
        
        // 6. Forcer la détection des changements pour mettre à jour le select
        console.log('🔄 [populateFormFromPaiement] Valeurs finales assignées:');
        console.log('   - tauxRS:', this.tauxRS);
        console.log('   - valeurRetenue:', this.valeurRetenue);
        console.log('   - retenueSelection:', this.retenueSelection);
        this.cdr.detectChanges();

        // 5. Charger les lignes de paiement dans les sections
        if (paiement.lignes_paiement && paiement.lignes_paiement.length > 0) {
            this.populateSectionsWithOriginalMontants(paiement);
        } else {
            this.cdr.detectChanges();
        }
        this.emitResteAPayerCalcule();
    }

    /**
     * Méthode pour remplir les sections avec les montants originaux
     */
    private populateSectionsWithOriginalMontants(paiement: Paiement): void {
        if (paiement.lignes_paiement && paiement.lignes_paiement.length > 0) {
            this.allSections = [];
            this.sectionCounter = 1;
            this.fenetre = 0;

            paiement.lignes_paiement.forEach((ligne) => {
                const sectionId = this.sectionCounter++;
                this.fenetre++;

                let sectionType: 'espece' | 'cheque' | 'virement' | 'traite' | 'avoir' = 'espece';
                if (ligne.type_paiement === 'cheque') {
                    sectionType = 'cheque';
                } else if (ligne.type_paiement === 'virement') {
                    sectionType = 'virement';
                } else if (ligne.type_paiement === 'traite') {
                    sectionType = 'traite';
                } else if (ligne.type_paiement === 'avoir') {
                    sectionType = 'avoir';
                }

                // Section Avoir : uniquement montant et avoir_id
                if (sectionType === 'avoir') {
                    const sectionDataAvoir: any = {
                        montant: ligne.montant || '',
                        avoir_id: (paiement as any).avoir_id ?? this.documentId ?? null
                    };
                    this.allSections.push({
                        id: sectionId,
                        type: 'avoir',
                        isContentVisible: false,
                        data: sectionDataAvoir,
                        isExisting: true
                    });
                    return;
                }

                let soldeTypeFromLigne: 'primaire' | 'secondaire' = 'secondaire';
                if (ligne.soldeType && (ligne.soldeType === 'primaire' || ligne.soldeType === 'secondaire')) {
                    soldeTypeFromLigne = ligne.soldeType;
                } else if (ligne.solde_primaire && parseFloat(ligne.solde_primaire) > 0) {
                    soldeTypeFromLigne = 'primaire';
                }
                
                const tresorerieId = ligne.tresorerie_id ?? (ligne as any).tresorerie_id ?? (ligne as any).operation_tresorerie_id ?? (ligne as any).tresorerie?.id ?? null;
                const sectionData: any = {
                    montant: ligne.montant || '',
                    date_reglement: ligne.date_reglement || new Date().toISOString().split('T')[0],
                    solde_primaire: this.currentSoldePrimaire || ligne.solde_primaire || '0.00',
                    solde_secondaire: this.currentSoldeSecondaire || ligne.solde_secondaire || '0.00',
                    soldeType: soldeTypeFromLigne,
                    tresorerie_id: tresorerieId
                };

                if (ligne.fichier) {
                    try {
                        // Essayer de parser comme JSON si c'est une chaîne JSON
                        if (typeof ligne.fichier === 'string' && ligne.fichier.startsWith('[')) {
                            sectionData.fichiersUploades = JSON.parse(ligne.fichier);
                        } else if (Array.isArray(ligne.fichier)) {
                            sectionData.fichiersUploades = ligne.fichier;
                        } else {
                            // Si c'est une simple chaîne, créer un tableau avec un seul élément
                            sectionData.fichiersUploades = [ligne.fichier];
                        }
                    } catch (e) {
                        // Si le parsing échoue, traiter comme une chaîne simple
                        sectionData.fichiersUploades = [ligne.fichier];
                    }
                }

                if (sectionType === 'cheque') {
                    sectionData.porteur = ligne.porteur || '';
                    sectionData.banque_id = ligne.banque_id || null;
                    sectionData.numero_cheque = ligne.numero_cheque || '';
                } else if (sectionType === 'virement') {
                    sectionData.informations_virement = ligne.informations_virement || '';
                    sectionData.compte_bancaire_id = ligne.compte_bancaire_id || null;
                } else if (sectionType === 'traite') {
                    sectionData.compte_source = ligne.compte_source || '';
                    sectionData.numero_traite = ligne.numero_traite || '';
                    sectionData.date_echeance = ligne.date_echeance || '';
                    sectionData.compte_bancaire_id = ligne.compte_bancaire_id || null;
                }

                this.allSections.push({
                    id: sectionId,
                    type: sectionType,
                    isContentVisible: false,
                    data: sectionData,
                    isExisting: true
                });
            });
        }
        this.cdr.detectChanges();
        this.emitResteAPayerCalcule();
    }

    private getDocumentIdFromAvoir(avoir: any): number | null {
        if (!avoir) return null;
        const d = avoir.fullData || avoir;
        if (d.id != null) return Number(d.id);
        if (avoir.id != null) return Number(avoir.id);
        if (d.document_id != null) return Number(d.document_id);
        if (avoir.document_id != null) return Number(avoir.document_id);
        return null;
    }

    private getMontantAvoir(avoir: any): number {
        const rev = avoir?.revenue ?? avoir?.total_ttc ?? avoir?.net_payer ?? 0;
        if (typeof rev === 'number') return rev;
        const num = parseFloat(String(rev).replace(/[^\d.,]/g, '').replace(',', '.'));
        return isNaN(num) ? 0 : num;
    }

    /** Retourne l'ID avoir à enregistrer sur le paiement (Depuis un avoir, ou document avoir, ou section avoir). */
    private getAvoirIdForPaiement(): number | null {
        if (this.avoirPourPaiement) {
            return this.getDocumentIdFromAvoir(this.avoirPourPaiement);
        }
        const avoirSection = this.allSections.find(s => s.type === 'avoir');
        if (avoirSection?.data?.avoir_id != null) {
            return Number(avoirSection.data.avoir_id);
        }
        if (this.shouldShowSectionAvoir() && this.documentId != null) {
            return this.documentId;
        }
        return null;
    }

    /** ID utilisé pour les appels API getPaiementsByDocumentId : facture d'origine quand document = avoir, sinon documentId. */
    private getDocumentIdForPaiementApi(): number | null {
        if (this.documentType === 'avoir' && this.factureIdForAvoir != null) {
            return this.factureIdForAvoir;
        }
        return this.documentId ?? null;
    }

    /** @param skipResteEmit true après création paiement pour éviter NG0100 (ne pas émettre 0 au parent avant fermeture du modal). */
    private resetForm(skipResteEmit: boolean = false): void {
        this.allSections = [];
        this.sectionCounter = 1;
        this.fenetre = 0;
        this.retenueSelection = 'non';
        this.valeurRetenue = false;
        this.timbreSelection = 'non';
        this.montantTTC = 0;
        this.netAPayer = 0;
        this.montantRetenue = 0;
        this.tauxRS = '10';
        this.inclureTimbreDansBaseRS = false;
        this.existingPaiementId = null; // Réinitialiser l'ID du paiement existant
        this.avoirPourPaiement = null;
        if (!skipResteEmit) {
            this.emitResteAPayerCalcule();
        }
        this.cdr.detectChanges();
    }

    /**
     * Créer les opérations de trésorerie pour chaque ligne de paiement
     * Cette méthode est appelée après la création/mise à jour réussie d'un paiement
     * Le backend mettra automatiquement à jour la facture, le solde trésorerie et générera l'historique solde
     * 
     * Différences entre Vente et Achat :
     * - Vente (facture) : type_paiement = 'credit', type_operation = 'recette' (flux entrant, augmente le solde)
     * - Achat (facture fournisseur) : type_paiement = 'debit', type_operation = 'depense' (flux sortant, diminue le solde)
     * 
     * IMPORTANT: Cette méthode ne crée des opérations que pour les NOUVELLES lignes (sans ID).
     * Les lignes existantes (avec ID) sont ignorées car elles ont déjà leurs opérations de trésorerie.
     */
    private createTresorerieOperations(paiement: Paiement, lignesPaiement: LignePaiement[]): void {
        // Protection contre les appels multiples simultanés
        if (this.isCreatingTresorerieOperations) {
            console.warn('⚠️ [createTresorerieOperations] Création déjà en cours, appel ignoré pour éviter les doublons');
            return;
        }

        // Filtrer les lignes espece et virement à envoyer en trésorerie (POST).
        // On ne filtre pas sur !ligne.id : les lignes passées sont celles qu'on vient d'envoyer au backend (création ou ajout),
        // donc on crée bien une opération trésorerie pour chaque ligne espèce/virement.
        const typeNorm = (t: string | undefined) => (t || '').toLowerCase().trim();
        const nouvellesLignes = (lignesPaiement || []).filter(ligne => {
            const type = typeNorm(ligne.type_paiement);
            return type === 'espece' || type === 'virement';
        });
        
        if (nouvellesLignes.length === 0) {
            console.log('ℹ️ [createTresorerieOperations] Aucune ligne de type espece/virement à traiter (lignes reçues:', lignesPaiement?.length || 0, ')');
            this.isCreatingTresorerieOperations = false;
            return;
        }
        
        console.log('💰 [createTresorerieOperations] Filtrage: uniquement espece et virement');
        console.log('💰 [createTresorerieOperations] Lignes filtrées (espece/virement):', nouvellesLignes.length);

        console.log('💰 [createTresorerieOperations] Début de la création des opérations de trésorerie');
        console.log('💰 [createTresorerieOperations] Nombre total de lignes reçues:', lignesPaiement.length);
        console.log('💰 [createTresorerieOperations] Nombre de NOUVELLES lignes à traiter:', nouvellesLignes.length);
        console.log('💰 [createTresorerieOperations] Paiement ID:', paiement.id);
        console.log('💰 [createTresorerieOperations] Document ID:', paiement.document_id);
        console.log('💰 [createTresorerieOperations] Document ref_externe:', this.documentRefExterne);
        console.log('💰 [createTresorerieOperations] Document type:', this.documentType);
        console.log('💰 [createTresorerieOperations] client_id SOURCE — this.clientId:', this.clientId, '(type:', typeof this.clientId, ')');
        console.log('💰 [createTresorerieOperations] client_id SOURCE — paiement.client_id:', paiement.client_id, '(type:', typeof (paiement as any).client_id, ')');
        
        // Activer le flag pour éviter les appels multiples
        this.isCreatingTresorerieOperations = true;
        
        // Déterminer si c'est un paiement d'achat ou de vente
        // Vérifier plusieurs formats possibles pour le documentType
        const docTypeLower = (this.documentType || '').toLowerCase().trim();
        const docTypeUpper = (this.documentType || '').toUpperCase().trim();
        
        // Détection robuste du type de document
        const isAchat = docTypeLower === 'facture-fournisseur' || 
                       docTypeLower === 'facture fournisseur' ||
                       docTypeUpper === 'FACTURE FOURNISSEUR' ||
                       docTypeUpper === 'FACTURE-FOURNISSEUR' ||
                       docTypeLower.includes('fournisseur') ||
                       docTypeUpper.includes('FOURNISSEUR');
        
        const typePaiement = isAchat ? 'debit' : 'credit'; // Achat = débit (sortie), Vente = crédit (entrée)
        const typeOperation = isAchat ? 'depense' : 'recette'; // Achat = dépense, Vente = recette
        
        console.log('🔍 [createTresorerieOperations] Détection du type:', {
            documentType: this.documentType,
            docTypeLower: docTypeLower,
            docTypeUpper: docTypeUpper,
            isAchat: isAchat,
            typePaiement: typePaiement,
            typeOperation: typeOperation
        });
        
        // Vérification de sécurité : si le type n'est pas clairement identifié, logger un avertissement
        if (!this.documentType || this.documentType.trim() === '') {
            console.warn('⚠️ [createTresorerieOperations] documentType est vide ou null, utilisation de "facture" par défaut');
        }
        
        console.log('💰 [createTresorerieOperations] Type de paiement:', typePaiement, '(isAchat:', isAchat, ')');
        console.log('💰 [createTresorerieOperations] Type d\'opération:', typeOperation);

        // Récupérer l'utilisateur et la station
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const userId = currentUser?.id;
        const stationId = currentUser?.stations?.[0]?.id;

        if (!userId || !stationId) {
            console.error('❌ [createTresorerieOperations] Utilisateur ou station non disponible');
            this.isCreatingTresorerieOperations = false;
            return;
        }

        // Récupérer le ref_externe du document si non fourni, puis lancer les POST trésorerie (ne pas bloquer indéfiniment)
        const getDocumentRefExterne = (cb: (refExterne: string | null) => void): void => {
            let done = false;
            const refExterneTimeout = setTimeout(() => {
                if (!done) {
                    done = true;
                    console.warn('⚠️ [createTresorerieOperations] Timeout ref_externe : on lance le POST trésorerie avec document_reference null');
                    cb(null);
                }
            }, 8000);
            const safeCall = (ref: string | null) => {
                if (done) return;
                done = true;
                clearTimeout(refExterneTimeout);
                cb(ref);
            };
            if (this.documentRefExterne) {
                safeCall(this.documentRefExterne);
                return;
            }
            if (this.documentId) {
                console.log('📥 [createTresorerieOperations] Récupération du document pour obtenir ref_externe');
                this.documentService.getDocumentById(this.documentId).subscribe({
                    next: (response: any) => {
                        let document: any;
                        if (response && response.data && response.data.document) {
                            document = response.data.document;
                        } else if (response && response.data) {
                            document = response.data;
                        } else if (response) {
                            document = response;
                        }
                        const refExterne = document?.ref_externe || null;
                        console.log('✅ [createTresorerieOperations] ref_externe récupéré:', refExterne);
                        safeCall(refExterne);
                    },
                    error: (error) => {
                        console.error('❌ [createTresorerieOperations] Erreur lors de la récupération du document:', error);
                        safeCall(null);
                    }
                });
            } else {
                safeCall(null);
            }
        };

        // Sécurité : si le callback n'est jamais appelé, réinitialiser le flag après délai
        const resetFlagTimeout = setTimeout(() => {
            if (this.isCreatingTresorerieOperations) {
                console.warn('⚠️ [createTresorerieOperations] Timeout de sécurité : réinitialisation du flag');
                this.isCreatingTresorerieOperations = false;
            }
        }, 35000);

        // Créer une opération de trésorerie pour chaque NOUVELLE ligne de paiement
        // IMPORTANT: Créer les opérations SÉQUENTIELLEMENT (une par une) pour éviter les conflits de transactions
        getDocumentRefExterne((documentRefExterne) => {
            let operationsCreated = 0;
            let operationsFailed = 0;

            // Fonction pour créer une opération de trésorerie de manière séquentielle
            const createOperationSequentially = (index: number): Promise<void> => {
                return new Promise((resolve, reject) => {
                    if (index >= nouvellesLignes.length) {
                        // Toutes les opérations ont été traitées
                        clearTimeout(resetFlagTimeout);
                        console.log('💰 [createTresorerieOperations] Fin de la création séquentielle des opérations de trésorerie');
                        if (operationsFailed === 0) {
                            console.log('✅ [createTresorerieOperations] Toutes les opérations de trésorerie ont été créées avec succès');
                            console.log('✅ [createTresorerieOperations] Le backend mettra à jour automatiquement:');
                            console.log('   - La facture (statut)');
                            console.log('   - Le solde UNIQUEMENT selon solde_type de chaque opération');
                            console.log('   - L\'historique solde');
                        } else {
                            console.warn(`⚠️ [createTresorerieOperations] ${operationsCreated} opérations créées, ${operationsFailed} échecs`);
                        }
                        // Réinitialiser le flag
                        this.isCreatingTresorerieOperations = false;
                        resolve();
                        return;
                    }

                    const ligne = nouvellesLignes[index];
                    
                    // Trouver la section correspondante pour obtenir le soldeType
                    // PRIORITÉ 1: Utiliser l'index stocké dans la ligne si disponible
                    let section: any = null;
                    const sectionIndex = (ligne as any)._sectionIndex;
                    
                    if (sectionIndex !== undefined && sectionIndex !== null && this.allSections[sectionIndex]) {
                        section = this.allSections[sectionIndex];
                    } else if (this.allSections[index]) {
                        // PRIORITÉ 2: Utiliser l'index de la boucle
                        section = this.allSections[index];
                    } else {
                        // PRIORITÉ 3: Chercher par type et montant
                        section = this.allSections.find(s => {
                            return s.type === ligne.type_paiement && 
                                   Math.abs(parseFloat(s.data?.montant || '0') - parseFloat(ligne.montant || '0')) < 0.01;
                        });
                    }

                    // Récupérer le soldeType : PRIORITÉ ABSOLUE à la section trouvée (c'est ce que l'utilisateur a sélectionné)
                    let soldeType: string = 'secondaire'; // Par défaut
                    
                    if (section && section.data && section.data.soldeType) {
                        // La section existe et a un soldeType : utiliser celui-ci (c'est la sélection de l'utilisateur)
                        soldeType = String(section.data.soldeType);
                        console.log(`✅ [createTresorerieOperations] Ligne ${index + 1}: soldeType récupéré depuis section.data.soldeType = "${soldeType}"`);
                    } else if (ligne.soldeType) {
                        // Fallback : utiliser le soldeType stocké dans la ligne
                        soldeType = String(ligne.soldeType);
                        console.log(`✅ [createTresorerieOperations] Ligne ${index + 1}: soldeType récupéré depuis ligne.soldeType = "${soldeType}"`);
                    } else {
                        console.warn(`⚠️ [createTresorerieOperations] Ligne ${index + 1}: soldeType non trouvé, utilisation du défaut "secondaire"`);
                        if (section) {
                            console.warn(`⚠️ [createTresorerieOperations] Section trouvée mais section.data.soldeType est:`, section.data?.soldeType);
                            console.warn(`⚠️ [createTresorerieOperations] Section.data complet:`, JSON.stringify(section.data, null, 2));
                        } else {
                            console.warn(`⚠️ [createTresorerieOperations] Aucune section trouvée pour cette ligne`);
                        }
                    }
                    
                    const soldeTypeFinal: string = String(soldeType || 'secondaire');
                    console.log(`📋 [createTresorerieOperations] Ligne ${index + 1}: type=${ligne.type_paiement}, montant=${ligne.montant}, solde_type="${soldeTypeFinal}"`);

                    // Récupérer banque_id et compte_bancaire_id depuis la section (sélection de l'utilisateur)
                    // PRIORITÉ 1: Depuis section.data (sélection de l'utilisateur)
                    // PRIORITÉ 2: Depuis ligne (fallback)
                    let banqueId: number | null = null;
                    let compteBancaireId: number | null = null;

                    if (section && section.data) {
                        // Pour les chèques: banque_id est sélectionné dans le formulaire
                        if (ligne.type_paiement === 'cheque') {
                            banqueId = section.data.banque_id || ligne.banque_id || null;
                            // Pour les chèques, compte_bancaire_id peut aussi être défini si un compte bancaire est associé
                            compteBancaireId = section.data.compte_bancaire_id || ligne.compte_bancaire_id || null;
                        }
                        // Pour les virements et traites: compte_bancaire_id est sélectionné dans le formulaire
                        else if (ligne.type_paiement === 'virement' || ligne.type_paiement === 'traite') {
                            compteBancaireId = section.data.compte_bancaire_id || ligne.compte_bancaire_id || null;
                            // Si compte_bancaire_id est défini, on peut aussi utiliser banque_id si disponible
                            banqueId = section.data.banque_id || ligne.banque_id || null;
                        }
                        // Pour les espèces: pas de banque/compte bancaire nécessaire
                        else {
                            banqueId = section.data.banque_id || ligne.banque_id || null;
                            compteBancaireId = section.data.compte_bancaire_id || ligne.compte_bancaire_id || null;
                        }
                    } else {
                        // Fallback: utiliser les valeurs de la ligne si la section n'est pas trouvée
                        banqueId = ligne.banque_id || null;
                        compteBancaireId = ligne.compte_bancaire_id || null;
                    }

                    console.log(`🏦 [createTresorerieOperations] Ligne ${index + 1}: banque_id et compte_bancaire_id récupérés depuis la section:`);
                    console.log(`   - banque_id: ${banqueId} (depuis section: ${section?.data?.banque_id || 'N/A'}, depuis ligne: ${ligne.banque_id || 'N/A'})`);
                    console.log(`   - compte_bancaire_id: ${compteBancaireId} (depuis section: ${section?.data?.compte_bancaire_id || 'N/A'}, depuis ligne: ${ligne.compte_bancaire_id || 'N/A'})`);

                    // Créer l'opération de trésorerie (client_id = client du document vente, fournisseur_id = fournisseur du document achat)
                    const clientIdTresorerie = isAchat ? null : (this.clientId ?? paiement.client_id ?? null);
                    const fournisseurIdTresorerie = isAchat ? (this.fournisseurId ?? (paiement as any).fournisseur_id ?? null) : null;
                    const depuisAvoir = (paiement.avoir_id != null && paiement.avoir_id !== undefined) ? 1 : 0;
                    // Paiement avoir : type_paiement = debit (utilisation d'avoir), sinon credit pour vente / debit pour achat
                    const typePaiementFinal = depuisAvoir ? 'debit' : typePaiement;
                    const typeOperationFinal = depuisAvoir ? 'depense' : typeOperation;
                    console.log(`💰 [createTresorerieOperations] Ligne ${index + 1} — client_id:`, clientIdTresorerie, '| fournisseur_id:', fournisseurIdTresorerie, '| isAchat:', isAchat);
                    const operationTresorerie: Tresorerie = {
                        document_id: paiement.document_id || null,
                        client_id: clientIdTresorerie,
                        fournisseur_id: fournisseurIdTresorerie,
                        depuis_avoir: depuisAvoir,
                        document_reference: documentRefExterne || null, // Utiliser ref_externe du document au lieu de la référence du paiement
                        document_type: isAchat ? 'facture-fournisseur' : 'facture',
                        paiement_id: paiement.id || null,
                        date_operation: ligne.date_reglement || new Date().toISOString().split('T')[0],
                        type_operation: typeOperationFinal, // 'depense' pour avoir, 'recette' pour vente, 'depense' pour achat
                        type_paiement: typePaiementFinal, // 'debit' pour paiement avoir, 'credit' pour vente, 'debit' pour achat
                        montant: ligne.montant || '0',
                        montant_ttc: ligne.montant || '0',
                        methode_paiement: ligne.type_paiement as 'espece' | 'cheque' | 'virement' | 'traite',
                        solde_type: soldeTypeFinal, // IMPORTANT: Ce solde_type doit être utilisé par le backend pour mettre à jour UNIQUEMENT le solde correspondant
                        numero_cheque: ligne.numero_cheque || null,
                        numero_traite: ligne.numero_traite || null,
                        date_echeance: ligne.date_echeance || null,
                        porteur: ligne.porteur || null,
                        banque_id: banqueId, // Utiliser la valeur récupérée depuis la section
                        compte_bancaire_id: compteBancaireId, // Utiliser la valeur récupérée depuis la section
                        informations_virement: ligne.informations_virement || null,
                        note: `${isAchat ? 'Paiement fournisseur' : 'Paiement client'} ${paiement.reference || ''} - ${ligne.type_paiement} - Solde ${soldeTypeFinal}`,
                        description: `${isAchat ? 'Paiement fournisseur' : 'Paiement client'} ${paiement.reference || ''} - ${ligne.type_paiement} - Solde ${soldeTypeFinal}`,
                        user_id: userId,
                        station_id: stationId,
                        statut: 'actif',
                        categorie_id: null
                    };

                    console.log(`📤 [createTresorerieOperations] ═══════════════════════════════════════════════════════`);
                    console.log(`📤 [createTresorerieOperations] Création SÉQUENTIELLE de l'opération de trésorerie ${index + 1}/${nouvellesLignes.length} (NOUVELLE LIGNE):`);
                    console.log(`📤 [createTresorerieOperations]   - Ligne ID: ${ligne.id || 'NOUVEAU (sans ID)'}`);
                    console.log(`📤 [createTresorerieOperations]   - Montant: ${operationTresorerie.montant} TND`);
                    console.log(`📤 [createTresorerieOperations]   - solde_type: "${operationTresorerie.solde_type}" ⚠️ CRITIQUE`);
                    console.log(`📤 [createTresorerieOperations]   - Le backend DOIT mettre à jour UNIQUEMENT le solde ${operationTresorerie.solde_type}`);
                    console.log(`📤 [createTresorerieOperations]   - Si solde_type="primaire" → mettre à jour SEULEMENT le solde primaire`);
                    console.log(`📤 [createTresorerieOperations]   - Si solde_type="secondaire" → mettre à jour SEULEMENT le solde secondaire`);
                    console.log(`📤 [createTresorerieOperations]   - banque_id: ${operationTresorerie.banque_id || 'null'} (depuis section sélectionnée)`);
                    console.log(`📤 [createTresorerieOperations]   - compte_bancaire_id: ${operationTresorerie.compte_bancaire_id || 'null'} (depuis section sélectionnée)`);
                    console.log(`📤 [createTresorerieOperations]   - document_reference: ${documentRefExterne}`);
                    console.log(`📤 [createTresorerieOperations]   - type_paiement: ${operationTresorerie.type_paiement}`);
                    console.log(`📤 [createTresorerieOperations]   - type_operation: ${operationTresorerie.type_operation}`);
                    console.log(`📤 [createTresorerieOperations]   - client_id: ${operationTresorerie.client_id ?? 'null'}`);
                    console.log(`📤 [createTresorerieOperations]   - fournisseur_id: ${operationTresorerie.fournisseur_id ?? 'null'}`);
                    console.log(`📤 [createTresorerieOperations] ═══════════════════════════════════════════════════════`);
                    console.log('📤 [createTresorerieOperations] REQUÊTE POST TRÉSORERIE (body envoyé):', JSON.stringify(operationTresorerie, null, 2));

                    // Créer l'opération de trésorerie de manière séquentielle
                    this.tresorerieService.createTresorerie(operationTresorerie).subscribe({
                        next: (result) => {
                            operationsCreated++;
                            console.log(`✅ [createTresorerieOperations] Opération de trésorerie ${index + 1}/${nouvellesLignes.length} créée avec succès`);
                            console.log(`✅ [createTresorerieOperations]   - solde_type envoyé: "${operationTresorerie.solde_type}"`);
                            console.log(`✅ [createTresorerieOperations]   - Le backend DOIT mettre à jour UNIQUEMENT le solde ${operationTresorerie.solde_type}`);
                            console.log(`✅ [createTresorerieOperations]   - Résultat:`, result);
                            
                            // Attendre un court délai pour éviter les conflits de transaction, puis créer la prochaine opération
                            setTimeout(() => {
                                createOperationSequentially(index + 1).then(() => resolve()).catch(reject);
                            }, 100); // Délai de 100ms entre chaque opération
                        },
                        error: (error) => {
                            operationsFailed++;
                            const status = error?.status;
                            const body = error?.error;
                            const msg = (typeof body === 'object' && body?.message) ? body.message
                                : (typeof body === 'string') ? body
                                : error?.message || 'Erreur inconnue';
                            const detail = (typeof body === 'object' && body?.errors) ? JSON.stringify(body.errors) : '';
                            console.error(`❌ [createTresorerieOperations] Erreur lors de la création de l'opération de trésorerie ${index + 1}/${nouvellesLignes.length}:`, error);
                            console.error(`❌ [createTresorerieOperations] Status: ${status}, message: ${msg}, body:`, body);
                            this.toastr.warning(
                                status ? `Trésorerie (${status}) : ${msg}${detail ? ' — ' + detail : ''}` : `Trésorerie : ${msg}`,
                                'Trésorerie non enregistrée',
                                { timeOut: 8000 }
                            );
                            // Continuer avec la prochaine opération même en cas d'erreur
                            setTimeout(() => {
                                createOperationSequentially(index + 1).then(() => resolve()).catch(reject);
                            }, 100);
                        }
                    });
                });
            };

            // Démarrer la création séquentielle des opérations
            console.log('💰 [createTresorerieOperations] Début de la création SÉQUENTIELLE des opérations de trésorerie');
            createOperationSequentially(0).catch((error) => {
                clearTimeout(resetFlagTimeout);
                console.error('❌ [createTresorerieOperations] Erreur fatale lors de la création séquentielle:', error);
                // Réinitialiser le flag en cas d'erreur fatale
                this.isCreatingTresorerieOperations = false;
            });
        });
    }

    /**
     * Créer les lignes chequetraite pour les types cheque et traite
     * Cette méthode est appelée après la création/mise à jour réussie d'un paiement
     * IMPORTANT: Cette méthode ne crée des lignes que pour les NOUVELLES lignes (sans ID) de type 'cheque' ou 'traite'.
     * Les lignes existantes (avec ID) sont ignorées car elles ont déjà leurs lignes chequetraite.
     */
    private createChequeTraiteOperations(paiement: Paiement, lignesPaiement: LignePaiement[]): void {
        // Filtrer uniquement les NOUVELLES lignes (sans ID) de type 'cheque' ou 'traite'
        const nouvellesLignes = lignesPaiement.filter(ligne => 
            !ligne.id && (ligne.type_paiement === 'cheque' || ligne.type_paiement === 'traite')
        );
        
        if (nouvellesLignes.length === 0) {
            console.log('ℹ️ [createChequeTraiteOperations] Aucune nouvelle ligne de type cheque/traite à traiter');
            return;
        }

        console.log('💳 [createChequeTraiteOperations] Début de la création des lignes chequetraite');
        console.log('💳 [createChequeTraiteOperations] Nombre total de lignes reçues:', lignesPaiement.length);
        console.log('💳 [createChequeTraiteOperations] Nombre de NOUVELLES lignes cheque/traite à traiter:', nouvellesLignes.length);
        console.log('💳 [createChequeTraiteOperations] Paiement ID:', paiement.id);
        console.log('💳 [createChequeTraiteOperations] Document ID:', paiement.document_id);
        console.log('💳 [createChequeTraiteOperations] Document type:', this.documentType);
        
        // Déterminer si c'est un paiement d'achat ou de vente
        const docTypeLower = (this.documentType || '').toLowerCase().trim();
        const docTypeUpper = (this.documentType || '').toUpperCase().trim();
        
        const isAchat = docTypeLower === 'facture-fournisseur' || 
                       docTypeLower === 'facture fournisseur' ||
                       docTypeUpper === 'FACTURE FOURNISSEUR' ||
                       docTypeUpper === 'FACTURE-FOURNISSEUR' ||
                       docTypeLower.includes('fournisseur') ||
                       docTypeUpper.includes('FOURNISSEUR');
        
        // type_operation: 'emis' pour achat (fournisseur), 'recu' pour vente (client)
        const typeOperation = isAchat ? 'emis' : 'recu';
        
        console.log('🔍 [createChequeTraiteOperations] Détection du type:', {
            documentType: this.documentType,
            isAchat: isAchat,
            typeOperation: typeOperation
        });

        // Récupérer l'utilisateur et la station
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const userId = currentUser?.id;
        const stationId = currentUser?.stations?.[0]?.id;

        if (!userId || !stationId) {
            console.error('❌ [createChequeTraiteOperations] Utilisateur ou station non disponible');
            return;
        }

        // Récupérer le document pour obtenir client_id ou fournisseur_id
        const getDocumentData = (callback: (clientId: number | null, fournisseurId: number | null) => void): void => {
            if (!this.documentId) {
                callback(null, null);
                return;
            }

            console.log('📥 [createChequeTraiteOperations] Récupération du document pour obtenir client_id/fournisseur_id');
            this.documentService.getDocumentById(this.documentId).subscribe({
                next: (response: any) => {
                    let document: any;
                    if (response && response.data && response.data.document) {
                        document = response.data.document;
                    } else if (response && response.data) {
                        document = response.data;
                    } else if (response) {
                        document = response;
                    }
                    
                    const clientId = document?.client_id || null;
                    const fournisseurId = document?.fournisseur_id || null;
                    
                    console.log('✅ [createChequeTraiteOperations] Données du document récupérées:', {
                        client_id: clientId,
                        fournisseur_id: fournisseurId
                    });
                    
                    callback(clientId, fournisseurId);
                },
                error: (error) => {
                    console.error('❌ [createChequeTraiteOperations] Erreur lors de la récupération du document:', error);
                    callback(null, null);
                }
            });
        };

        // Créer une ligne chequetraite pour chaque NOUVELLE ligne de paiement de type cheque ou traite
        getDocumentData((clientId, fournisseurId) => {
            let operationsCreated = 0;
            let operationsFailed = 0;

            // Fonction pour créer une ligne chequetraite de manière séquentielle
            const createOperationSequentially = (index: number): Promise<void> => {
                return new Promise((resolve, reject) => {
                    if (index >= nouvellesLignes.length) {
                        // Toutes les opérations ont été traitées
                        console.log('💳 [createChequeTraiteOperations] Fin de la création séquentielle des lignes chequetraite');
                        if (operationsFailed === 0) {
                            console.log('✅ [createChequeTraiteOperations] Toutes les lignes chequetraite ont été créées avec succès');
                        } else {
                            console.warn(`⚠️ [createChequeTraiteOperations] ${operationsCreated} lignes créées, ${operationsFailed} échecs`);
                        }
                        resolve();
                        return;
                    }

                    const ligne = nouvellesLignes[index];
                    
                    // Trouver la section correspondante pour obtenir le soldeType
                    let section: any = null;
                    const sectionIndex = (ligne as any)._sectionIndex;
                    
                    if (sectionIndex !== undefined && sectionIndex !== null && this.allSections[sectionIndex]) {
                        section = this.allSections[sectionIndex];
                    } else if (this.allSections[index]) {
                        section = this.allSections[index];
                    } else {
                        section = this.allSections.find(s => {
                            return s.type === ligne.type_paiement && 
                                   Math.abs(parseFloat(s.data?.montant || '0') - parseFloat(ligne.montant || '0')) < 0.01;
                        });
                    }

                    // Récupérer le soldeType
                    let soldeType: string = 'secondaire';
                    
                    if (section && section.data && section.data.soldeType) {
                        soldeType = String(section.data.soldeType);
                    } else if (ligne.soldeType) {
                        soldeType = String(ligne.soldeType);
                    }
                    
                    const soldeTypeFinal: string = String(soldeType || 'secondaire');

                    // Récupérer banque_id depuis la section (sélection de l'utilisateur)
                    // PRIORITÉ 1: Depuis section.data (sélection de l'utilisateur)
                    // PRIORITÉ 2: Depuis ligne (fallback)
                    let banqueId: number | null = null;
                    if (section && section.data) {
                        banqueId = section.data.banque_id || ligne.banque_id || null;
                    } else {
                        banqueId = ligne.banque_id || null;
                    }

                    console.log(`🏦 [createChequeTraiteOperations] Ligne ${index + 1}: banque_id récupéré depuis la section:`);
                    console.log(`   - banque_id: ${banqueId} (depuis section: ${section?.data?.banque_id || 'N/A'}, depuis ligne: ${ligne.banque_id || 'N/A'})`);

                    // Calculer le montant avec signe : négatif pour emis, positif pour recu
                    const montantBrut = parseFloat(ligne.montant || '0');
                    const montantAvecSigne = typeOperation === 'emis' ? -Math.abs(montantBrut) : Math.abs(montantBrut);

                    // Préparer les dates
                    const dateReglement = ligne.date_reglement || new Date().toISOString().split('T')[0];
                    
                    // Pour numero_cheque : obligatoire même pour les traites
                    // Si c'est une traite et que numero_cheque est vide, utiliser numero_traite
                    // Si c'est un chèque et que numero_cheque est vide, générer une valeur par défaut
                    let numeroCheque = ligne.numero_cheque || null;
                    if (ligne.type_paiement === 'traite' && !numeroCheque && ligne.numero_traite) {
                        numeroCheque = ligne.numero_traite;
                    } else if (ligne.type_paiement === 'cheque' && !numeroCheque) {
                        // Pour les chèques, numero_cheque est obligatoire
                        // Générer une valeur par défaut si absente
                        numeroCheque = `CHQ-${paiement.reference || Date.now()}-${index + 1}`;
                        console.warn(`⚠️ [createChequeTraiteOperations] numero_cheque manquant pour le chèque, valeur par défaut générée: ${numeroCheque}`);
                    }

                    // Créer la ligne chequetraite avec tous les champs requis (client_id = client du document)
                    const chequeTraite: any = {
                        type_operation: typeOperation,
                        type: ligne.type_paiement as 'cheque' | 'traite', // Champ requis par l'API
                        type_paiement: ligne.type_paiement as 'cheque' | 'traite',
                        client_id: isAchat ? null : (this.clientId ?? paiement.client_id ?? clientId),
                        montant: montantAvecSigne.toString(),
                        solde_type: soldeTypeFinal,
                        porteur: ligne.porteur || null,
                        banque_id: banqueId, // Utiliser la valeur récupérée depuis la section
                        numero_cheque: numeroCheque, // Obligatoire même pour les traites
                        numero_traite: ligne.numero_traite || null,
                        date_echeance: ligne.date_echeance || null,
                        date_paiement: dateReglement, // Champ requis par l'API
                        date_reglement: dateReglement,
                        note: `${isAchat ? 'Paiement fournisseur' : 'Paiement client'} ${paiement.reference || ''} - ${ligne.type_paiement} - Solde ${soldeTypeFinal}`,
                        paiement: paiement.id || null, // Ajouter l'ID du paiement
                        depuis: 'paiement', // Indiquer que le chèque/traite provient d'un paiement
                        statut: 'en_cours', // Statut par défaut pour les chèques/traites créés depuis un paiement (format backend)
                        station_id: stationId,
                        user_id: userId
                    };

                    console.log(`📤 [createChequeTraiteOperations] ═══════════════════════════════════════════════════════`);
                    console.log(`📤 [createChequeTraiteOperations] Création SÉQUENTIELLE de la ligne chequetraite ${index + 1}/${nouvellesLignes.length}:`);
                    console.log(`📤 [createChequeTraiteOperations]   - Ligne ID: ${ligne.id || 'NOUVEAU (sans ID)'}`);
                    console.log(`📤 [createChequeTraiteOperations]   - Type: ${chequeTraite.type_paiement}`);
                    console.log(`📤 [createChequeTraiteOperations]   - Montant: ${chequeTraite.montant} TND (${typeOperation === 'emis' ? 'négatif pour emis' : 'positif pour recu'})`);
                    console.log(`📤 [createChequeTraiteOperations]   - solde_type: "${chequeTraite.solde_type}"`);
                    console.log(`📤 [createChequeTraiteOperations]   - banque_id: ${chequeTraite.banque_id || 'null'} (depuis section sélectionnée)`);
                    console.log(`📤 [createChequeTraiteOperations]   - client_id: ${chequeTraite.client_id}`);
                    console.log(`📤 [createChequeTraiteOperations]   - paiement: ${chequeTraite.paiement || 'null'} (ID du paiement)`);
                    console.log(`📤 [createChequeTraiteOperations]   - depuis: "${chequeTraite.depuis}" (origine du chèque/traite)`);
                    console.log(`📤 [createChequeTraiteOperations]   - statut: "${chequeTraite.statut}"`);
                    console.log(`📤 [createChequeTraiteOperations] ═══════════════════════════════════════════════════════`);

                    // Créer la ligne chequetraite de manière séquentielle
                    this.tresorerieService.createChequeTraite(chequeTraite).subscribe({
                        next: (result) => {
                            operationsCreated++;
                            console.log(`✅ [createChequeTraiteOperations] Ligne chequetraite ${index + 1}/${nouvellesLignes.length} créée avec succès`);
                            console.log(`✅ [createChequeTraiteOperations]   - Résultat:`, result);
                            
                            // Attendre un court délai pour éviter les conflits de transaction
                            setTimeout(() => {
                                createOperationSequentially(index + 1).then(() => resolve()).catch(reject);
                            }, 100);
                        },
                        error: (error) => {
                            operationsFailed++;
                            console.error(`❌ [createChequeTraiteOperations] Erreur lors de la création de la ligne chequetraite ${index + 1}/${nouvellesLignes.length}:`, error);
                            console.error(`❌ [createChequeTraiteOperations] Détails de l'erreur:`, {
                                status: error.status,
                                message: error.message,
                                error: error.error
                            });
                            
                            // Continuer avec la prochaine opération même en cas d'erreur
                            setTimeout(() => {
                                createOperationSequentially(index + 1).then(() => resolve()).catch(reject);
                            }, 100);
                        }
                    });
                });
            };

            // Démarrer la création séquentielle des lignes chequetraite
            console.log('💳 [createChequeTraiteOperations] Début de la création SÉQUENTIELLE des lignes chequetraite');
            createOperationSequentially(0).catch((error) => {
                console.error('❌ [createChequeTraiteOperations] Erreur fatale lors de la création séquentielle:', error);
            });
        });
    }

    /**
     * Met à jour le statut du document après un paiement.
     * La référence est toujours le "reste à payer" (comme dans paiement-facture) :
     * - Retenue à la source Non → référence = montant total (facture)
     * - Retenue à la source Oui → référence = Net à payer TTC
     * - Si total payé >= référence → "Payé" (ID: 5)
     * - Si total payé > 0 mais < référence → "Partiellement payé"
     * - Si total payé = 0 → "Non payé" (ID: 12)
     */
    private updateDocumentStatusAfterPaiement(paiement: Paiement, allLignesPaiement: LignePaiement[]): void {
        // Mettre à jour le statut pour les factures (vente) et factures fournisseurs (achat)
        if (this.documentType !== 'facture' && this.documentType !== 'facture-fournisseur') {
            console.log('ℹ️ [updateDocumentStatusAfterPaiement] Type de document:', this.documentType, '- Mise à jour du statut ignorée (seulement pour factures et factures fournisseurs)');
            return;
        }

        if (!this.documentId) {
            console.warn('⚠️ [updateDocumentStatusAfterPaiement] documentId manquant');
            return;
        }

        // Récupérer l'utilisateur et la station
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const stationId = currentUser?.stations?.[0]?.id;

        if (!stationId) {
            console.warn('⚠️ [updateDocumentStatusAfterPaiement] stationId manquant');
            return;
        }

        console.log('🔄 [updateDocumentStatusAfterPaiement] Début de la mise à jour du statut');
        console.log('🔄 [updateDocumentStatusAfterPaiement] documentId:', this.documentId);
        console.log('🔄 [updateDocumentStatusAfterPaiement] documentType:', this.documentType);

        // Critère unique pour "Payé" : le RESTE à PAYER affiché dans le tableau (paiement-facture) est 0.00
        // On capture cette valeur MAINTENANT (avant toute requête async) pour ne pas dépendre de retenue Oui/Non ni du reset du formulaire
        const resteAPayerTableau = this.getResteAPayerCalcule();
        const tolerance = 0.05;
        console.log('💰 [updateDocumentStatusAfterPaiement] RESTE à PAYER (tableau, retenue', this.valeurRetenue ? 'Oui' : 'Non', '):', resteAPayerTableau);

        // Récupérer TOUS les paiements du document pour calculer le total réellement payé (facture d'origine si avoir)
        const effectiveDocId = this.getDocumentIdForPaiementApi();
        if (!effectiveDocId) {
            console.warn('⚠️ [updateDocumentStatusAfterPaiement] Pas d\'id document effectif');
            return;
        }
        this.paiementService.getPaiementsByDocumentId(effectiveDocId).subscribe({
            next: (response: any) => {
                // Règle unique : si RESTE à PAYER (tel qu'affiché dans paiement-facture) est 0.00 → Payé (Oui ou Non retenue)
                if (resteAPayerTableau <= tolerance) {
                    console.log('✅ [updateDocumentStatusAfterPaiement] RESTE à PAYER = 0.00 → Statut: Payé');
                    this.updateStatutDocument(5, 'Payé', stationId);
                    return;
                }

                // Normaliser la réponse
                let allPaiements: Paiement[] = [];
                if (Array.isArray(response)) {
                    allPaiements = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        allPaiements = response.data;
                    } else if (response.data.paiements && Array.isArray(response.data.paiements)) {
                        allPaiements = response.data.paiements;
                    } else if (response.data.paiement && typeof response.data.paiement === 'object') {
                        allPaiements = [response.data.paiement];
                    }
                } else if (response && typeof response === 'object' && response.id) {
                    allPaiements = [response];
                }

                // Montant du paiement qu'on vient de créer/mettre à jour (source fiable, évite données API obsolètes)
                const montantPaiementCourant = (allLignesPaiement?.length)
                    ? allLignesPaiement.reduce((s, l) => s + parseFloat(l.montant || '0'), 0)
                    : 0;

                // Calculer le total payé : pour le paiement courant, utiliser toujours le montant envoyé (allLignesPaiement)
                // pour éviter "Partiellement payé" quand l'API renvoie des données pas encore à jour ou des arrondis différents
                let totalPaye = 0;
                const paiementDejaInclus = paiement?.id && allPaiements.some((p: any) => p.id === paiement.id);
                allPaiements.forEach(p => {
                    if (p.id === paiement?.id && allLignesPaiement?.length) {
                        totalPaye += montantPaiementCourant;
                    } else if (p.lignes_paiement && Array.isArray(p.lignes_paiement)) {
                        p.lignes_paiement.forEach((ligne: LignePaiement) => {
                            totalPaye += parseFloat(ligne.montant || '0');
                        });
                    }
                });
                if (!paiementDejaInclus && montantPaiementCourant > 0) {
                    totalPaye += montantPaiementCourant;
                    console.log('💰 [updateDocumentStatusAfterPaiement] Paiement courant non encore dans l\'API, ajout au total:', montantPaiementCourant, '→ totalPaye:', totalPaye);
                }

                // Arrondir à 2 décimales pour éviter erreurs de flottant (reste à payer = 0 → Payé)
                totalPaye = Math.round(totalPaye * 100) / 100;

                // Référence = Net à payer TTC (peut être 211.9452) ou montant total facture
                const montantReferenceBrut = this.valeurRetenue ? this.netAPayer : this.montantTotal;
                const montantReference = Math.round(montantReferenceBrut * 100) / 100;
                // tolerance déjà défini avant subscribe (0.05)

                // Reste à payer après ce paiement (référence − total payé)
                const resteAPayerApresPaiement = Math.round((montantReferenceBrut - totalPaye) * 100) / 100;

                console.log('💰 [updateDocumentStatusAfterPaiement] Calcul du statut:');
                console.log('  - Nombre de paiements:', allPaiements.length);
                console.log('  - Total payé (tous paiements):', totalPaye);
                console.log('  - Net à payer (référence brute):', montantReferenceBrut, '→ arrondi:', montantReference);
                console.log('  - Reste à payer après paiement:', resteAPayerApresPaiement);

                let nouveauStatutId: number | null = null;
                let nouveauStatutLabel: string = '';

                // Payé si : reste ≤ 0, ou total payé ≥ net à payer (avec tolérance arrondi)
                const estPayeIntegralement = resteAPayerApresPaiement <= tolerance
                    || totalPaye >= montantReferenceBrut - tolerance
                    || (allLignesPaiement?.length && montantPaiementCourant >= montantReferenceBrut - tolerance);

                if (montantReferenceBrut <= tolerance) {
                    nouveauStatutId = 5;
                    nouveauStatutLabel = 'Payé';
                    console.log('✅ [updateDocumentStatusAfterPaiement] Statut: Payé (référence nulle)');
                } else if (estPayeIntegralement) {
                    nouveauStatutId = 5;
                    nouveauStatutLabel = 'Payé';
                    console.log('✅ [updateDocumentStatusAfterPaiement] Statut: Payé (reste à payer ≤ 0 ou montant couvert)');
                } else if (totalPaye > tolerance) {
                    // Partiellement payé - Récupérer l'ID dynamiquement depuis l'API
                    console.log('⚠️ [updateDocumentStatusAfterPaiement] Statut: Partiellement payé (total payé < reste à payer)');
                    console.log('⚠️ [updateDocumentStatusAfterPaiement] Récupération de l\'ID du statut "Partiellement payé" depuis l\'API...');
                    
                    // Récupérer tous les statuts depuis l'API pour trouver l'ID de "Partiellement payé"
                    this.documentService.getStatutDocuments().subscribe({
                        next: (statutsResponse: any) => {
                            let statuts: any[] = [];
                            if (Array.isArray(statutsResponse)) {
                                statuts = statutsResponse;
                            } else if (statutsResponse?.data && Array.isArray(statutsResponse.data)) {
                                statuts = statutsResponse.data;
                            } else if (statutsResponse?.data && typeof statutsResponse.data === 'object') {
                                statuts = [statutsResponse.data];
                            }

                            console.log('📋 [updateDocumentStatusAfterPaiement] Statuts disponibles:', statuts.map((s: any) => ({ id: s.id, titre: s.titre })));

                            // Chercher le statut "Partiellement payé" (avec différentes variantes)
                            const partiellementPayeStatut = statuts.find((s: any) => 
                                s.titre?.toLowerCase().includes('partiellement') ||
                                s.titre?.toLowerCase().includes('partiel') ||
                                s.titre?.toLowerCase() === 'partiellement payé' ||
                                s.titre?.toLowerCase() === 'partiellement paye'
                            );

                            if (partiellementPayeStatut && partiellementPayeStatut.id) {
                                const statutId = partiellementPayeStatut.id;
                                const statutLabel = partiellementPayeStatut.titre || 'Partiellement payé';
                                console.log('✅ [updateDocumentStatusAfterPaiement] ID du statut "Partiellement payé" trouvé:', statutId);
                                this.updateStatutDocument(statutId, statutLabel, stationId);
                            } else {
                                console.warn('⚠️ [updateDocumentStatusAfterPaiement] Statut "Partiellement payé" non trouvé dans l\'API.');
                                console.warn('⚠️ [updateDocumentStatusAfterPaiement] Utilisation de l\'ID 15 par défaut...');
                                // Fallback vers ID 15 si le statut n'est pas trouvé
                                this.updateStatutDocument(15, 'Partiellement payé', stationId);
                            }
                        },
                        error: (err) => {
                            console.error('❌ [updateDocumentStatusAfterPaiement] Erreur lors de la récupération des statuts:', err);
                            console.warn('⚠️ [updateDocumentStatusAfterPaiement] Utilisation de l\'ID 15 par défaut...');
                            // Fallback vers ID 15 en cas d'erreur
                            this.updateStatutDocument(15, 'Partiellement payé', stationId);
                        }
                    });
                    return; // Sortir car la mise à jour sera faite dans le callback
                } else {
                    // Aucun paiement
                    nouveauStatutId = 12; // Non payé
                    nouveauStatutLabel = 'Non payé';
                    console.log('ℹ️ [updateDocumentStatusAfterPaiement] Statut: Non payé (aucun paiement)');
                }

                // Mettre à jour le statut directement (pour Payé et Non payé)
                if (nouveauStatutId) {
                    this.updateStatutDocument(nouveauStatutId, nouveauStatutLabel, stationId);
                }
            },
            error: (error) => {
                console.error('❌ [updateDocumentStatusAfterPaiement] Erreur lors de la récupération des paiements:', error);
                // En cas d'erreur, utiliser les lignes fournies en paramètre comme fallback
                let totalPaye = 0;
                if (allLignesPaiement?.length) {
                    allLignesPaiement.forEach(ligne => {
                        totalPaye += parseFloat(ligne.montant || '0');
                    });
                    totalPaye = Math.round(totalPaye * 100) / 100;
                }

                const montantReferenceBrut = this.valeurRetenue ? this.netAPayer : this.montantTotal;
                const tolerance = 0.05;
                const resteAPayerApresPaiement = Math.round((montantReferenceBrut - totalPaye) * 100) / 100;
                let nouveauStatutId: number | null = null;

                if (resteAPayerApresPaiement <= tolerance || totalPaye >= montantReferenceBrut - tolerance) {
                    nouveauStatutId = 5; // Payé
                } else if (totalPaye > tolerance) {
                    nouveauStatutId = 15; // Partiellement payé
                } else {
                    nouveauStatutId = 12; // Non payé
                }

                if (nouveauStatutId && stationId) {
                    this.documentService.updateStatut(this.documentId!, {
                        statut_id: nouveauStatutId,
                        station_id: stationId
                    }).subscribe({
                        next: () => console.log('✅ [updateDocumentStatusAfterPaiement] Statut mis à jour (fallback)'),
                        error: (err) => console.error('❌ [updateDocumentStatusAfterPaiement] Erreur fallback:', err)
                    });
                }
            }
        });
    }

    /**
     * Méthode helper pour mettre à jour le statut du document
     */
    private updateStatutDocument(statutId: number, statutLabel: string, stationId: number): void {
        if (!statutId || !this.documentId) {
            console.warn('⚠️ [updateStatutDocument] statutId ou documentId manquant', { statutId, documentId: this.documentId });
            return;
        }

        console.log('🔄 [updateStatutDocument] Mise à jour du statut du document:', {
            documentId: this.documentId,
            statutId: statutId,
            statutLabel: statutLabel,
            stationId: stationId
        });

        this.documentService.updateStatut(this.documentId, {
            statut_id: statutId,
            station_id: stationId
        }).subscribe({
            next: (response) => {
                console.log('✅ [updateStatutDocument] Statut du document mis à jour avec succès:', statutLabel);
                console.log('✅ [updateStatutDocument] Réponse complète:', response);
                this.toastr.success(`Statut mis à jour: ${statutLabel}`, 'Succès', {
                    timeOut: 3000,
                    positionClass: 'toast-bottom-right'
                });
                
                // Rafraîchir les données pour afficher le nouveau statut en temps réel
                console.log('🔄 [updateStatutDocument] Rafraîchissement des données...');
                this.dataService.loadByTypeAndStatus('Facture', 'Tous');
                
                // Rafraîchir aussi le statut spécifique si nécessaire
                if (statutLabel === 'Partiellement payé' || statutLabel === 'partiellement payé') {
                    this.dataService.loadByTypeAndStatus('Facture', 'partiellement payé');
                } else if (statutLabel === 'Payé') {
                    this.dataService.loadByTypeAndStatus('Facture', 'Payé');
                } else if (statutLabel === 'Non payé') {
                    this.dataService.loadByTypeAndStatus('Facture', 'Non payé');
                }
            },
            error: (error) => {
                console.error('❌ [updateStatutDocument] Erreur lors de la mise à jour du statut:', error);
                console.error('❌ [updateStatutDocument] Détails de l\'erreur:', {
                    status: error?.status,
                    statusText: error?.statusText,
                    message: error?.message,
                    error: error?.error,
                    statutIdTente: statutId,
                    documentId: this.documentId,
                    stationId: stationId
                });
                
                // Afficher un message d'erreur à l'utilisateur
                this.toastr.error(`Erreur lors de la mise à jour du statut: ${error?.error?.message || error?.message || 'Erreur inconnue'}`, 'Erreur', {
                    timeOut: 5000,
                    positionClass: 'toast-bottom-right'
                });
            }
        });
    }
}
